/**
 * Brilinton Apple Watch configurator — modular client runtime.
 * Expects JSON in #b1-watch-data-{sectionId} and root #b1-watch-{sectionId}.
 */
(function () {
  'use strict';

  function norm(s) {
    if (s == null) return '';
    return String(s)
      .toLowerCase()
      .replace(/\u2019/g, "'")
      .replace(/[\s_]+/g, ' ')
      .trim();
  }



  function inferWatchWareHost(entry) {
    var raw = [
      entry && entry.hostKind,
      entry && entry.host_kind,
      entry && entry.hostDevice,
      entry && entry.host_device,
      entry && entry.lineHostDevice,
      entry && entry.profileName,
      entry && entry.line,
      entry && entry.productTitle,
      entry && entry.productHandle,
      entry && entry.title,
    ].filter(Boolean).join(' ');
    var n = norm(raw);
    if (n === 'royal' || n.indexOf('royal pop') >= 0 || n.indexOf('royalpop') >= 0 || n.indexOf('b1 head') >= 0 || n.indexOf('b head') >= 0) return 'royal';
    if (n === 'apple' || n.indexOf('apple watch') >= 0 || n.indexOf('applewatch') >= 0) return 'apple';
    return '';
  }

  function filterWatchWareEntries(entries, host) {
    var target = host === 'royal_pop' || host === 'royal' ? 'royal' : 'apple';
    return (entries || []).filter(function (entry) {
      var kind = inferWatchWareHost(entry);
      if (target === 'royal') return kind === 'royal';
      return kind === 'apple' || kind === '';
    });
  }

  function q(root, sel) {
    return root.querySelector(sel);
  }

  function qa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  /** Click target can be a text node in some browsers; closest() only exists on Elements. */
  function closestFromEvent(e, sel) {
    var t = e && e.target;
    if (!t) return null;
    if (t.nodeType !== 1) t = t.parentElement;
    return t && t.closest ? t.closest(sel) : null;
  }

  function fmtMoney(cents, rootEl) {
    var fmt = rootEl.getAttribute('data-money-format');
    if (!fmt) fmt = '{{amount}}';
    var cur = rootEl.getAttribute('data-currency') || '';
    var n = (Number(cents) || 0) / 100;
    if (fmt.indexOf('amount') >= 0) {
      return fmt
        .replace(/\{\{\s*amount\s*\}\}/gi, n.toFixed(2))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/gi, Math.round(n).toString());
    }
    return n.toLocaleString(undefined, { style: 'currency', currency: cur || 'USD' });
  }

  function optByIndex(v, idx) {
    if (idx === 0) return v.option1;
    if (idx === 1) return v.option2;
    return v.option3 || '';
  }

  function b1LinkStudioKey(finish, linkSize) {
    function slug(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/[™®©]/g, '')
        .replace(/[¹]/g, '1')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }
    var finishKey = slug(finish);
    var sizeKey = slug(linkSize);
    return finishKey && sizeKey ? finishKey + '-' + sizeKey : '';
  }

  function resolveB1LinkStudioImage(bLink, finish, linkSize) {
    if (!bLink || !bLink.studio_images) return null;
    var key = b1LinkStudioKey(finish, linkSize);
    return key && bLink.studio_images[key] ? bLink.studio_images[key] : null;
  }

  function uniqueVals(variants, idx) {
    var seen = {};
    var out = [];
    for (var i = 0; i < variants.length; i++) {
      var f = optByIndex(variants[i], idx);
      if (!f || seen[norm(f)]) continue;
      seen[norm(f)] = true;
      out.push(f);
    }
    return out;
  }


  function findVariantByIndices(product, iA, valA, iB, valB, opts) {
    opts = opts || {};
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (norm(optByIndex(v, iA)) === norm(valA) && norm(optByIndex(v, iB)) === norm(valB)) return v;
    }
    if (opts.exactOnly) return null;
    for (var j = 0; j < product.variants.length; j++) {
      if (product.variants[j].available) return product.variants[j];
    }
    return product.variants[0];
  }

  function extractColorFromTitle(title) {
    if (!title) return '';
    var parts = String(title).split('|');
    var tail = parts.length > 1 ? parts[parts.length - 1] : title;
    var dash = tail.split('-');
    return (dash[dash.length - 1] || tail).trim();
  }

  function productEdition(title) {
    var t = norm(title);
    if (t.indexOf('monarch crystals') >= 0 || t.indexOf('monarch crystal') >= 0) return 'crystal';
    if (t.indexOf('monarch steel') >= 0) return 'steel';
    return null;
  }

  /* ---------- Transparent PNG crop (B¹ Studio Royal only — not collection) ---------- */
  var TRANSPARENT_CROP_CACHE = Object.create(null);
  var TRANSPARENT_CROP_PENDING = Object.create(null);
  var TRANSPARENT_ALPHA_MIN = 12;
  var TRANSPARENT_BOUNDS_SCAN_MAX = 640;

  /**
   * Royal Pop device PNG — transparent bounds probe + optional canvas crop.
   */
  function analyzeRoyalPopModelCrop(img, crownPosition) {
    var nw = img.naturalWidth;
    var nh = img.naturalHeight;
    var audit = {
      sourceUrl: img.src || null,
      naturalWidth: nw,
      naturalHeight: nh,
      probeScanMax: TRANSPARENT_BOUNDS_SCAN_MAX,
      alphaMin: TRANSPARENT_ALPHA_MIN,
      crownPosition: crownPosition || null,
      visibleBounds: null,
      cropBounds: null,
      cropSkipped: true,
      cropSkipReason: null,
      canvasNormalized: false,
      finalCanvasSize: { width: nw, height: nh },
      bodyAttach: null,
      opaqueAreaRatio: null,
      bodyHeightVsCanvasRatio: null,
    };

    if (nw < 2 || nh < 2) {
      audit.cropSkipReason = 'invalidSourceDimensions';
      return { url: img.src, topFrac: null, botFrac: null, audit: audit };
    }

    try {
      var scan = Math.min(1, TRANSPARENT_BOUNDS_SCAN_MAX / Math.max(nw, nh));
      audit.probeScanScale = scan;
      var sw = Math.max(1, Math.round(nw * scan));
      var sh = Math.max(1, Math.round(nh * scan));
      var probe = document.createElement('canvas');
      probe.width = sw;
      probe.height = sh;
      var pctx = probe.getContext('2d');
      pctx.drawImage(img, 0, 0, sw, sh);
      var bounds = findOpaqueBounds(pctx, sw, sh, TRANSPARENT_ALPHA_MIN);
      if (!bounds) {
        audit.cropSkipReason = 'noOpaquePixels';
        return { url: img.src, topFrac: null, botFrac: null, audit: audit };
      }

      var inv = 1 / scan;
      var minX = Math.max(0, Math.floor(bounds.minX * inv) - 2);
      var minY = Math.max(0, Math.floor(bounds.minY * inv) - 2);
      var maxX = Math.min(nw - 1, Math.ceil(bounds.maxX * inv) + 2);
      var maxY = Math.min(nh - 1, Math.ceil(bounds.maxY * inv) + 2);
      var cw = maxX - minX + 1;
      var ch = maxY - minY + 1;

      audit.visibleBounds = {
        minX: minX,
        minY: minY,
        maxX: maxX,
        maxY: maxY,
        width: cw,
        height: ch,
      };
      audit.opaqueAreaRatio = Math.round(((cw * ch) / (nw * nh)) * 10000) / 10000;

      var bodyTopFull = bounds.bodyTopY * inv;
      var bodyBotFull = bounds.bodyBottomY * inv;

      var isCrown12 = typeof crownPosition === 'string' && crownPosition.indexOf('12') >= 0;
      if (isCrown12) {
        var tightThresh = bounds.maxRowW * 0.62;
        var rw = bounds.rowW;
        for (var ty = bounds.bodyTopY; ty <= bounds.bodyBottomY; ty++) {
          if (rw[ty] >= tightThresh) {
            bodyTopFull = ty * inv;
            break;
          }
        }
        for (var by = bounds.bodyBottomY; by >= bounds.bodyTopY; by--) {
          if (rw[by] >= tightThresh) {
            bodyBotFull = by * inv;
            break;
          }
        }
        var bodyH = bodyBotFull - bodyTopFull;
        bodyTopFull += bodyH * 0.012;
        bodyBotFull -= bodyH * 0.003;
      }

      var bodyHeightPx = bodyBotFull - bodyTopFull;
      audit.bodyAttach = {
        bodyTopPx: Math.round(bodyTopFull * 100) / 100,
        bodyBottomPx: Math.round(bodyBotFull * 100) / 100,
        bodyHeightPx: Math.round(bodyHeightPx * 100) / 100,
      };

      if (cw < 2 || ch < 2 || (cw >= nw * 0.98 && ch >= nh * 0.98)) {
        audit.cropSkipped = true;
        audit.cropSkipReason =
          cw < 2 || ch < 2 ? 'cropBoxTooSmall' : 'opaqueSpan98pct';
        audit.finalCanvasSize = { width: nw, height: nh };
        audit.bodyAttach.topFrac = Math.max(0, bodyTopFull / nh);
        audit.bodyAttach.botFrac = Math.min(1, bodyBotFull / nh);
        audit.bodyHeightVsCanvasRatio =
          Math.round((bodyHeightPx / nh) * 10000) / 10000;
        return {
          url: img.src,
          topFrac: audit.bodyAttach.topFrac,
          botFrac: audit.bodyAttach.botFrac,
          audit: audit,
        };
      }

      audit.cropBounds = { minX: minX, minY: minY, width: cw, height: ch };
      audit.cropSkipped = false;
      audit.cropSkipReason = null;
      audit.canvasNormalized = true;
      audit.finalCanvasSize = { width: cw, height: ch };
      var cropTopF = Math.max(0, (bodyTopFull - minY) / ch);
      var cropBotF = Math.min(1, (bodyBotFull - minY) / ch);
      audit.bodyAttach.topFrac = cropTopF;
      audit.bodyAttach.botFrac = cropBotF;
      audit.bodyHeightVsCanvasRatio =
        Math.round((bodyHeightPx / ch) * 10000) / 10000;

      var out = document.createElement('canvas');
      out.width = cw;
      out.height = ch;
      out.getContext('2d').drawImage(img, minX, minY, cw, ch, 0, 0, cw, ch);
      return {
        url: out.toDataURL('image/png'),
        topFrac: cropTopF,
        botFrac: cropBotF,
        audit: audit,
      };
    } catch (err) {
      audit.cropSkipReason = 'analyzeError';
      audit.error = String(err && err.message ? err.message : err);
      return { url: img.src, topFrac: null, botFrac: null, audit: audit };
    }
  }

  function normalizeRoyalPopModelUrl(src, crownPosition) {
    var cacheKey = 'royalPopModel|' + src + '|' + (crownPosition || '');
    return new Promise(function (resolve) {
      if (!src) {
        resolve(null);
        return;
      }
      if (TRANSPARENT_CROP_CACHE[cacheKey]) {
        resolve(TRANSPARENT_CROP_CACHE[cacheKey]);
        return;
      }
      if (TRANSPARENT_CROP_PENDING[cacheKey]) {
        TRANSPARENT_CROP_PENDING[cacheKey].push(resolve);
        return;
      }
      TRANSPARENT_CROP_PENDING[cacheKey] = [resolve];

      function finish(result) {
        var out = result || { url: src, audit: { cropSkipReason: 'emptyResult' } };
        TRANSPARENT_CROP_CACHE[cacheKey] = out;
        var queue = TRANSPARENT_CROP_PENDING[cacheKey] || [];
        delete TRANSPARENT_CROP_PENDING[cacheKey];
        queue.forEach(function (fn) {
          fn(out);
        });
      }

      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        finish(analyzeRoyalPopModelCrop(img, crownPosition));
      };
      img.onerror = function () {
        finish({
          url: src,
          topFrac: null,
          botFrac: null,
          audit: { cropSkipReason: 'sourceLoadError', sourceUrl: src },
        });
      };
      img.src = src;
    });
  }

  var IMAGE_NATURAL_SIZE_CACHE = Object.create(null);
  var IMAGE_NATURAL_SIZE_PENDING = Object.create(null);

  function loadImageNaturalSize(url) {
    return new Promise(function (resolve) {
      if (!url) {
        resolve(null);
        return;
      }
      if (IMAGE_NATURAL_SIZE_CACHE[url]) {
        resolve(IMAGE_NATURAL_SIZE_CACHE[url]);
        return;
      }
      if (IMAGE_NATURAL_SIZE_PENDING[url]) {
        IMAGE_NATURAL_SIZE_PENDING[url].push(resolve);
        return;
      }
      IMAGE_NATURAL_SIZE_PENDING[url] = [resolve];
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        var size = {
          w: img.naturalWidth,
          h: img.naturalHeight,
        };
        IMAGE_NATURAL_SIZE_CACHE[url] = size;
        var queue = IMAGE_NATURAL_SIZE_PENDING[url] || [];
        delete IMAGE_NATURAL_SIZE_PENDING[url];
        queue.forEach(function (fn) {
          fn(size);
        });
      };
      img.onerror = function () {
        var queue = IMAGE_NATURAL_SIZE_PENDING[url] || [];
        delete IMAGE_NATURAL_SIZE_PENDING[url];
        queue.forEach(function (fn) {
          fn(null);
        });
      };
      img.src = url;
    });
  }

  function findOpaqueBounds(ctx, width, height, alphaMin) {
    var data = ctx.getImageData(0, 0, width, height).data;
    var minX = width;
    var minY = height;
    var maxX = 0;
    var maxY = 0;
    var rowW = new Uint16Array(height);
    for (var y = 0; y < height; y++) {
      var rowMinX = width;
      var rowMaxX = -1;
      for (var x = 0; x < width; x++) {
        if (data[(y * width + x) * 4 + 3] > alphaMin) {
          if (x < minX) minX = x;
          if (y < minY) minY = y;
          if (x > maxX) maxX = x;
          if (y > maxY) maxY = y;
          if (x < rowMinX) rowMinX = x;
          if (x > rowMaxX) rowMaxX = x;
        }
      }
      if (rowMaxX >= rowMinX) rowW[y] = rowMaxX - rowMinX + 1;
    }
    if (minX > maxX || minY > maxY) return null;

    var maxRowW = 0;
    for (var y = minY; y <= maxY; y++) {
      if (rowW[y] > maxRowW) maxRowW = rowW[y];
    }
    var bodyThresh = maxRowW * 0.50;

    var bestStart = minY, bestEnd = maxY, bestLen = 0;
    var runStart = -1, runLen = 0;
    for (var y = minY; y <= maxY; y++) {
      if (rowW[y] >= bodyThresh) {
        if (runStart < 0) runStart = y;
        runLen++;
      } else {
        if (runLen > bestLen) {
          bestStart = runStart;
          bestEnd = runStart + runLen - 1;
          bestLen = runLen;
        }
        runStart = -1;
        runLen = 0;
      }
    }
    if (runLen > bestLen) {
      bestStart = runStart;
      bestEnd = runStart + runLen - 1;
    }

    return {
      minX: minX, minY: minY, maxX: maxX, maxY: maxY,
      bodyTopY: bestStart,
      bodyBottomY: bestEnd,
      maxRowW: maxRowW,
      rowW: rowW
    };
  }


  /* Royal Pop 3 o'clock models need a separate anchor correction from the 12 o'clock models.
     Inspector-validated delta: left +21px, top +17px on a 367.475 × 329.671 rendered model. */
  var ROYAL_3_OCLOCK_OFFSET_X_RATIO = 0.057146744676508605;
  var ROYAL_3_OCLOCK_OFFSET_Y_RATIO = 0.051566561814657644;

  function parseStudioGeometry(raw, preferredLabels) {
    if (raw == null || raw === '') return null;

    function cleanLabel(v) {
      return norm(String(v || '').replace(/\|.*$/, '').replace(/\s+/g, ' ').trim());
    }

    var labels = [];
    if (Array.isArray(preferredLabels)) labels = preferredLabels;
    else if (preferredLabels != null) labels = [preferredLabels];
    labels = labels.map(cleanLabel).filter(Boolean);

    function numericGeometry(value) {
      var num = typeof value === 'number' ? value : parseFloat(String(value || '').trim().replace(/%$/, ''));
      return isFinite(num) ? { interfaceOffsetXPct: num } : null;
    }

    function parsePairString(txt) {
      txt = String(txt || '').trim();
      if (!txt) return null;

      /* New Studio X Offset list format:
         "49mm | 3.844" means: for 49mm, move center layer by 3.844% of rendered width.
         If several rows are ever emitted, the matching label is preferred; otherwise first valid row wins. */
      var rowParts = txt
        .split(/\r?\n|\|\||;/)
        .map(function (row) { return row.trim(); })
        .filter(Boolean);

      var fallback = null;
      for (var i = 0; i < rowParts.length; i++) {
        var row = rowParts[i];
        var m = row.match(/^(.+?)\s*[|:]\s*([+-]?\d+(?:\.\d+)?)/);
        if (!m) continue;
        var rowLabel = cleanLabel(m[1]);
        var rowValue = parseFloat(m[2]);
        if (!isFinite(rowValue)) continue;
        var geom = { interfaceOffsetXPct: rowValue };
        if (!fallback) fallback = geom;
        if (labels.length && labels.indexOf(rowLabel) !== -1) return geom;
      }
      if (fallback) return fallback;

      var single = numericGeometry(txt);
      if (single) return single;

      var parts = txt.split(',').map(function (v) { return parseFloat(v); });
      if (parts.length >= 2 && isFinite(parts[0]) && isFinite(parts[1])) {
        return { offsetX: parts[0], offsetY: parts[1] };
      }
      return null;
    }

    if (Array.isArray(raw)) {
      var fallbackArrayGeom = null;
      for (var a = 0; a < raw.length; a++) {
        var g = parseStudioGeometry(raw[a], labels);
        if (!g) continue;
        if (!fallbackArrayGeom) fallbackArrayGeom = g;
        if (!labels.length) return g;
        var rawLabel = cleanLabel(raw[a]);
        if (labels.indexOf(rawLabel) !== -1) return g;
      }
      return fallbackArrayGeom;
    }

    var data = raw;
    if (typeof raw === 'number') {
      return numericGeometry(raw);
    }
    if (typeof raw === 'string') {
      var txt = raw.trim();
      if (!txt) return null;
      try {
        data = JSON.parse(txt);
        if (typeof data === 'number') return numericGeometry(data);
        if (Array.isArray(data)) return parseStudioGeometry(data, labels);
      } catch (err) {
        return parsePairString(txt);
      }
    }
    if (!data || typeof data !== 'object') return null;
    var out = {};
    ['offsetX', 'offsetY', 'anchorX', 'anchorY', 'offsetXRatio', 'offsetYRatio', 'offsetXPercent', 'offsetYPercent', 'interfaceOffsetXPct', 'interfaceOffsetXPercent'].forEach(function (key) {
      if (data[key] == null) return;
      var num = parseFloat(data[key]);
      if (isFinite(num)) out[key] = num;
    });
    if (out.interfaceOffsetXPct == null && out.interfaceOffsetXPercent != null) {
      out.interfaceOffsetXPct = out.interfaceOffsetXPercent;
    }
    return out;
  }


  function isRoyalThreeOClock(crownPosition) {
    var v = norm(String(crownPosition || '').replace(/[’‘]/g, "'").replace(/[–—]/g, '-'));
    return /^3(?:\s*(?:o'?clock|oclock|o-clock))?$/.test(v);
  }

  function applyRoyalCrownPositionGeometry(geom, crownPosition) {
    var out = {};
    if (geom && typeof geom === 'object') {
      Object.keys(geom).forEach(function (key) { out[key] = geom[key]; });
    }
    if (!isRoyalThreeOClock(crownPosition)) return geom || null;

    /*
      3 o'clock Royal Pop correction must move ONLY the Royal Pop base layer.
      It must not move BandWare, B¹ Frame, or the shared interface axis.
      Therefore this is stored separately from offsetXRatio/offsetYRatio, because
      those values participate in the main composition geometry.
    */
    var cx = parseFloat(out.crownOffsetXRatio);
    var cy = parseFloat(out.crownOffsetYRatio);
    if (!isFinite(cx)) cx = 0;
    if (!isFinite(cy)) cy = 0;
    out.crownOffsetXRatio = cx + ROYAL_3_OCLOCK_OFFSET_X_RATIO;
    out.crownOffsetYRatio = cy + ROYAL_3_OCLOCK_OFFSET_Y_RATIO;
    return out;
  }

  function previewActiveSelector() {
    return '[data-studio-preview="active"]';
  }

  function sideStackSelector(value) {
    return '[data-studio-side-stack="' + value + '"]';
  }

  function layerWrapSelector(name) {
    return '.studio-preview__layer-wrap--' + name;
  }

  function layerWrapAnySelector() {
    return '.studio-preview__layer-wrap';
  }

  function isLayerWrap(wrap, name) {
    return !!(wrap && wrap.classList && (
      wrap.classList.contains('studio-preview__layer-wrap--' + name)
    ));
  }

  function isProductPreviewRoot(root) {
    return !!(root && root.classList && (
      root.classList.contains('studio-product-preview')
    ));
  }

  /* ---------- Preview engine ---------- */
  function PreviewEngine(root) {
    this.root = root;
    this._wwLayoutTimer = null;
    this.stacks = {
      active: q(root, previewActiveSelector()),
      prev: q(root, sideStackSelector('prev')),
      next: q(root, sideStackSelector('next')),
    };
    this.carouselShell = q(root, '[data-b1-carousel-shell]');
    this.activeTitle = q(root, '[data-b1-active-band-title]');
  }

  PreviewEngine.prototype.usesDirectStackLayout = function () {
    return (
      this.root.classList.contains('is-watchware-tab') ||
      this.root.classList.contains('is-bandware-tab')
    );
  };

  PreviewEngine.prototype._ensureStackResizeObserver = function () {
    if (this._stackResizeObs || typeof ResizeObserver === 'undefined') return;
    var self = this;
    this._stackResizeObs = new ResizeObserver(function () {
      if (self.root.classList.contains('is-ww-js-layout')) self._scheduleWatchWareLayout();
    });
    this.refreshStacks();
    [this.stacks.active, this.stacks.prev, this.stacks.next].forEach(function (st) {
      if (st) self._stackResizeObs.observe(st);
    });
  };

  PreviewEngine.prototype.setLayersOnStack = function (stackEl, layers, forceRefresh, useDirectLayout) {
    if (!stackEl) return;
    var self = this;
    var base = stackEl.querySelector('[data-layer="base"]');
    var band = stackEl.querySelector('[data-layer="band"]');
    var conn = stackEl.querySelector('[data-layer="connector"]');
    var b1Top = stackEl.querySelector('[data-layer="b1-top"]');
    var b1Bottom = stackEl.querySelector('[data-layer="b1-bottom"]');
    var wrapB1Top = stackEl.querySelector(layerWrapSelector('b1-top'));
    var wrapB1Bottom = stackEl.querySelector(layerWrapSelector('b1-bottom'));
    if (!base || !band) return;

    var showConn = layers.showConnector !== false && !!layers.connector;
    var showRoyalFrame = !!layers.showB1FrameBack && !!layers.b1FrameBack;
    var showRoyalWatchwareModel = !!layers.royalWatchwareModelBase;
    var showB1 = layers.showB1Connectors !== false && !!layers.b1Connector && !showRoyalFrame && !showRoyalWatchwareModel;
    var showRoyalCollFrame =
      showRoyalFrame && !layers.royalDirectComposition;
    /* B¹ Studio Royal Direct — is-rp-frame-back layout; collection uses showRoyalCollFrame. */
    var showRoyalStudioFrame =
      showRoyalFrame && !!layers.royalDirectComposition;
    var showRoyalB1FrameBottom = showRoyalCollFrame || showRoyalStudioFrame;
    stackEl.classList.toggle('is-two-layers', !showConn);
    if (conn) {
      conn.style.display = showConn ? '' : 'none';
    }
    if (b1Top) b1Top.style.display = showB1 ? '' : 'none';
    if (b1Bottom) b1Bottom.style.display = showB1 || showRoyalB1FrameBottom || showRoyalWatchwareModel ? '' : 'none';
    if (wrapB1Top) wrapB1Top.style.display = showB1 ? '' : 'none';
    if (wrapB1Bottom) wrapB1Bottom.style.display = showB1 || showRoyalB1FrameBottom || showRoyalWatchwareModel ? '' : 'none';

    function clearImg(img) {
      if (!img) return;
      img.classList.remove('is-visible');
      img.removeAttribute('data-studio-src-key'); img.removeAttribute('data-b1-src-key');
      img.removeAttribute('src');
    }

    function apply(img, url, srcKey) {
      if (!img) return;
      if (!url) {
        clearImg(img);
        if (useDirectLayout) self._scheduleWatchWareLayout();
        return;
      }
      function onReady() {
        img.classList.add('is-visible');
        if (useDirectLayout) self._scheduleWatchWareLayout();
      }
      var key = srcKey || url;
      if (forceRefresh || (img.getAttribute('data-studio-src-key') || img.getAttribute('data-b1-src-key')) !== key) {
        img.classList.remove('is-visible');
        img.setAttribute('data-studio-src-key', key); img.removeAttribute('data-b1-src-key');
        img.onload = onReady;
        img.onerror = onReady;
        img.src = url;
        if (img.complete) onReady();
      } else {
        onReady();
      }
    }

    function applyRoyalPopModelBase(img, url) {
      if (!url) return;
      if (!layers.normalizeBase) {
        apply(img, url, url);
        return;
      }
      normalizeRoyalPopModelUrl(url, layers.crownPosition).then(function (result) {
        apply(img, (result && result.url) || url, url);
        if (result && result.topFrac != null && result.botFrac != null) {
          img.setAttribute('data-studio-top-attach', String(result.topFrac));
          img.setAttribute('data-studio-bot-attach', String(result.botFrac));
        } else {
          img.removeAttribute('data-studio-top-attach');
          img.removeAttribute('data-studio-bot-attach');
          img.removeAttribute('data-b1-top-attach');
          img.removeAttribute('data-b1-bot-attach');
        }
        if (useDirectLayout) self._scheduleWatchWareLayout();
      });
    }

    stackEl.__b1Layers = layers || {};
    stackEl.classList.toggle('is-rp-direct-preview', !!layers.royalDirectComposition);
    stackEl.classList.toggle('is-rp-watchware-model', showRoyalWatchwareModel);
    stackEl.classList.toggle(
      'is-rp-frame-back',
      !!layers.royalDirectComposition && showRoyalFrame
    );
    if (layers.strapHeightRatio != null && isFinite(layers.strapHeightRatio)) {
      stackEl.setAttribute('data-studio-strap-ratio', String(layers.strapHeightRatio)); stackEl.removeAttribute('data-b1-strap-ratio');
    } else {
      stackEl.removeAttribute('data-studio-strap-ratio'); stackEl.removeAttribute('data-b1-strap-ratio');
    }
    if (layers.collectionB1Overlay) {
      stackEl.setAttribute('data-studio-coll-b1-overlay', '1');
    } else {
      stackEl.removeAttribute('data-studio-coll-b1-overlay'); stackEl.removeAttribute('data-b1-coll-b1-overlay');
    }
    stackEl.classList.add('is-morph');
    applyRoyalPopModelBase(base, layers.base);
    apply(band, layers.band, layers.band);
    apply(conn, showConn ? layers.connector : null, showConn ? layers.connector : null);
    var b1Src = showB1 ? layers.b1Connector : null;
    var b1Key = layers.b1ConnectorKey || b1Src;
    apply(b1Top, b1Src, b1Key ? b1Key + '|top' : null);
    apply(
      b1Bottom,
      showRoyalFrame ? layers.b1FrameBack : showRoyalWatchwareModel ? layers.royalWatchwareModelBase : b1Src,
      showRoyalFrame ? layers.b1FrameBack : showRoyalWatchwareModel ? layers.royalWatchwareModelBase : b1Key ? b1Key + '|bottom' : null
    );
  };

  PreviewEngine.prototype.pulse = function (direction) {
    if (!this.carouselShell) return;
    var shell = this.carouselShell;
    shell.classList.remove('is-transitioning', 'is-slide-next', 'is-slide-prev');
    if (direction === 'next') shell.classList.add('is-slide-next');
    if (direction === 'prev') shell.classList.add('is-slide-prev');
    void shell.offsetWidth;
    shell.classList.add('is-transitioning');
    window.setTimeout(function () {
      shell.classList.remove('is-transitioning', 'is-slide-next', 'is-slide-prev');
    }, 520);
  };

  PreviewEngine.prototype.refreshStacks = function () {
    this.stacks = {
      active: q(this.root, previewActiveSelector()),
      prev: q(this.root, sideStackSelector('prev')),
      next: q(this.root, sideStackSelector('next')),
    };
  };

  PreviewEngine.prototype.isValidView = function (view) {
    if (!view || !view.active) return false;
    return !!(view.active.base && view.active.band);
  };

  PreviewEngine.prototype.render = function (view, forceRefresh) {
    if (!view || !this.isValidView(view)) return;
    if (!this.stacks.active) this.refreshStacks();
    var force = !!forceRefresh;
    var useDirectLayout = this.usesDirectStackLayout();
    if (useDirectLayout) {
      this.root.classList.add('is-ww-js-layout');
      this._ensureStackResizeObserver();
    } else {
      this.root.classList.remove('is-ww-js-layout');
    }
    if (force && useDirectLayout) {
      this._clearWatchWareStackLayout(this.stacks.active);
    }
    this.setLayersOnStack(this.stacks.active, view.active || {}, force, useDirectLayout);
    if (this.stacks.prev && view.prev) {
      this.setLayersOnStack(this.stacks.prev, view.prev, force, useDirectLayout);
    }
    if (this.stacks.next && view.next) {
      this.setLayersOnStack(this.stacks.next, view.next, force, useDirectLayout);
    }
    if (this.activeTitle) this.activeTitle.textContent = view.title || '';
    if (this.carouselShell) this.carouselShell.classList.toggle('is-single', !!view.single);
    if (useDirectLayout) {
      this._scheduleWatchWareLayout();
    } else {
      this._clearWatchWareStackLayout(this.stacks.active);
      this._clearWatchWareStackLayout(this.stacks.prev);
      this._clearWatchWareStackLayout(this.stacks.next);
    }
  };

  var WW_TOUCH_PX = 2;

  /** Apple Watch device_image natural size — primes Royal collection device render match. */
  var B1_COLL_APPLE_REF_NATURAL = null;
  /** Apple collection Direct — tallest device_image (Noam demo: one scale for all layers). */
  var B1_COLL_APPLE_MAX_DEVICE_NATURAL = null;
  var ROYAL_COLL_DEVICE_RENDER_MAX = 1.5;
  /** Royal Pop collection — strap width vs rendered device (not wt × s). */
  var ROYAL_COLL_STRAP_TO_DEVICE_RATIO = 0.7;

  function initCollAppleReferenceProbe(url) {
    if (!url || (B1_COLL_APPLE_REF_NATURAL && B1_COLL_APPLE_REF_NATURAL.w > 1)) return;
    loadImageNaturalSize(url).then(function (sz) {
      if (!sz || sz.w < 2) return;
      B1_COLL_APPLE_REF_NATURAL = sz;
      if (typeof window !== 'undefined' && window.dispatchEvent) {
        window.dispatchEvent(new CustomEvent('b1-coll-apple-ref-ready'));
      }
    });
  }

  /** Apple collection Direct — probe all size device_image URLs; scale from tallest (Noam demo). */
  function initCollAppleMaxDeviceProbe(appleSizes) {
    if (!appleSizes || !appleSizes.length) return;
    var urls = [];
    appleSizes.forEach(function (entry) {
      if (entry && entry.device_image) urls.push(entry.device_image);
    });
    if (!urls.length) return;
    Promise.all(urls.map(loadImageNaturalSize)).then(function (sizes) {
      var maxH = 0;
      var maxW = 0;
      sizes.forEach(function (sz) {
        if (!sz || sz.h < 2) return;
        if (sz.h > maxH) maxH = sz.h;
        if (sz.w > maxW) maxW = sz.w;
      });
      if (maxH < 2) return;
      B1_COLL_APPLE_MAX_DEVICE_NATURAL = { maxH: maxH, maxW: maxW };
      if (typeof window !== 'undefined' && window.dispatchEvent) {
        window.dispatchEvent(new CustomEvent('b1-coll-apple-max-device-ready'));
      }
    });
  }

  /** Noam fixed scale — tallest Apple device_image; opts.maxDeviceHFrac / padWFrac per viewport. */
  function getAppleDirectFixedLayoutScale(cardW, cardH, wb, hbFallback, opts) {
    opts = opts || {};
    var maxDeviceHFrac = opts.maxDeviceHFrac != null ? opts.maxDeviceHFrac : 0.54;
    var padWFrac = opts.padWFrac != null ? opts.padWFrac : 0.9;
    var maxDeviceH = cardH * maxDeviceHFrac;
    var padW = cardW * padWFrac;
    var maxNat = B1_COLL_APPLE_MAX_DEVICE_NATURAL;
    var hbMax = maxNat && maxNat.maxH > 1 ? maxNat.maxH : hbFallback;
    var wbRef = maxNat && maxNat.maxW > 1 ? maxNat.maxW : wb;
    if (hbMax < 2) hbMax = hbFallback;
    if (wbRef < 2) wbRef = wb;
    return Math.min(1, maxDeviceH / hbMax, padW / wbRef);
  }

  function getAppleCollDirectLayoutScale(cardW, cardH, wb, hbFallback) {
    return getAppleDirectFixedLayoutScale(cardW, cardH, wb, hbFallback, {
      maxDeviceHFrac: 0.48,
      padWFrac: 0.84,
    });
  }

  function ensureAppleMaxDeviceRelayoutListener() {
    if (ensureAppleMaxDeviceRelayoutListener._bound) return;
    ensureAppleMaxDeviceRelayoutListener._bound = true;
    window.addEventListener('b1-coll-apple-max-device-ready', function () {
      qa(document, '.studio-product-preview,.b1-watch').forEach(function (root) {
        if (!root._b1App || typeof root._b1App.renderFromState !== 'function') return;
        root._b1App.renderFromState();
      });
    });
  }

  function collLayoutDevicePx(wb, hb, cardW, cardH) {
    var maxDeviceH = cardH * 0.48;
    var padW = cardW * 0.84;
    var sc = Math.min(1, maxDeviceH / hb, padW / wb);
    return {
      dWf: wb * sc,
      dHf: hb * sc,
      s: sc,
    };
  }

  /** Post-layout boost — device + B¹ frame only; straps use layout box unchanged. */
  function getRoyalCollDeviceRenderScale(wb, hb, cardW, cardH) {
    var ref = B1_COLL_APPLE_REF_NATURAL;
    if (!ref) return 1;
    var applePx = collLayoutDevicePx(ref.w, ref.h, cardW, cardH);
    var royalPx = collLayoutDevicePx(wb, hb, cardW, cardH);
    if (!royalPx.dHf || royalPx.dHf >= applePx.dHf * 0.995) return 1;
    return Math.min(ROYAL_COLL_DEVICE_RENDER_MAX, applePx.dHf / royalPx.dHf);
  }

  PreviewEngine.prototype._clearWatchWareStackLayout = function (stackEl) {
    if (!stackEl) return;
    [
      'band',
      'base',
      'b1-top',
      'b1-bottom',
      'connector',
    ].forEach(function (name) {
      var wrap = stackEl.querySelector(layerWrapSelector(name));
      if (!wrap) return;
      ['left', 'top', 'right', 'bottom', 'width', 'height', 'transform', 'zIndex', 'maxWidth', 'maxHeight'].forEach(function (p) {
        wrap.style[p] = '';
      });
      qa(wrap, 'img').forEach(function (im) {
        ['width', 'height', 'maxWidth', 'maxHeight', 'margin', 'left', 'top'].forEach(function (p) {
          im.style[p] = '';
        });
      });
    });
  };

  PreviewEngine.prototype._requestWatchWareStackLayout = function (stackEl) {
    if (!stackEl) return;
    var base = stackEl.querySelector('[data-layer="base"]');
    var band = stackEl.querySelector('[data-layer="band"]');
    var conn = stackEl.querySelector('[data-layer="connector"]');
    var b1Top = stackEl.querySelector('[data-layer="b1-top"]');
    var b1Bottom = stackEl.querySelector('[data-layer="b1-bottom"]');
    var self = this;
    var imgs = [];
    if (base && base.getAttribute('src')) imgs.push(base);
    if (band && band.getAttribute('src')) imgs.push(band);
    if (conn && conn.style.display !== 'none' && conn.getAttribute('src')) imgs.push(conn);
    if (
      b1Bottom &&
      b1Bottom.style.display !== 'none' &&
      b1Bottom.getAttribute('src')
    ) {
      imgs.push(b1Bottom);
    }
    if (b1Top && b1Top.style.display !== 'none' && b1Top.getAttribute('src')) {
      imgs.push(b1Top);
    }
    if (!imgs.length) {
      this._clearWatchWareStackLayout(stackEl);
      return;
    }
    var remain = imgs.length;
    function done() {
      remain -= 1;
      if (remain <= 0) self._layoutOneWatchWareStack(stackEl);
    }
    imgs.forEach(function (im) {
      function fin() {
        done();
      }
      if (im.complete) fin();
      else {
        im.addEventListener('load', fin, { once: true });
        im.addEventListener('error', fin, { once: true });
      }
    });
  };

  PreviewEngine.prototype._layoutOneWatchWareStack = function (stackEl) {
    if (!stackEl || !this.root.classList.contains('is-ww-js-layout')) return;
    var base = stackEl.querySelector('[data-layer="base"]');
    var band = stackEl.querySelector('[data-layer="band"]');
    var conn = stackEl.querySelector('[data-layer="connector"]');
    var b1Top = stackEl.querySelector('[data-layer="b1-top"]');
    var b1Bottom = stackEl.querySelector('[data-layer="b1-bottom"]');
    var wrapB = stackEl.querySelector(layerWrapSelector('band'));
    var wrapD = stackEl.querySelector(layerWrapSelector('base'));
    var wrapB1Top = stackEl.querySelector(layerWrapSelector('b1-top'));
    var wrapB1Bottom = stackEl.querySelector(layerWrapSelector('b1-bottom'));
    var wrapC = stackEl.querySelector(layerWrapSelector('connector'));
    if (!base || !band || !wrapB || !wrapD) return;

    var W = stackEl.clientWidth;
    var H = stackEl.clientHeight;
    if (W < 8 || H < 8) return;

    var isCollCard =
      this.root && this.root.classList.contains('studio-collection-card-preview');
    var isRoyalCollCard =
      isCollCard && this.root && this.root.classList.contains('is-royal-device');
    /* Apple Direct fixed band — collection cards + Studio Apple BandWare only. */
    var layersMeta = stackEl.__b1Layers || {};
    var showRoyalWatchwareModel = !!layersMeta.royalWatchwareModelBase || stackEl.classList.contains('is-rp-watchware-model');
    var isAppleDirectFixedBand =
      !isRoyalCollCard &&
      !this.root.classList.contains('is-royal-device') &&
      (
        !!layersMeta.appleDirectFixedScale ||
        (
          this.root.classList.contains('is-bandware-tab') &&
          !this.root.classList.contains('is-watchware-tab') &&
          (isCollCard || this.root.classList.contains('is-apple-device'))
        )
      );

    function nat(im) {
      if (!im || !im.getAttribute('src') || !im.complete || im.naturalWidth < 2) return null;
      return { w: im.naturalWidth, h: im.naturalHeight };
    }

    var db = nat(base);
    var dt = nat(band);
    if (!db || !dt) return;

    var wb = db.w;
    var hb = db.h;
    var wt = dt.w;
    var ht = dt.h;
    var useConn = conn && conn.style.display !== 'none' && conn.getAttribute('src');
    var dc = useConn ? nat(conn) : null;
    var wc = dc ? dc.w : 0;
    var hc = dc ? dc.h : 0;
    var isRpDirect = stackEl.classList.contains('is-rp-direct-preview');
    var isRpFrameBack = stackEl.classList.contains('is-rp-frame-back');
    var useB1 =
      !isRpFrameBack &&
      b1Top &&
      b1Bottom &&
      b1Top.style.display !== 'none' &&
      b1Bottom.style.display !== 'none';
    /* Collection grid: overlay B¹ lugs without studio strap reposition (studio unchanged). */
    var collB1Overlay = isCollCard && (stackEl.getAttribute('data-studio-coll-b1-overlay') === '1' || stackEl.getAttribute('data-b1-coll-b1-overlay') === '1');
    var useB1StrapLayout = useB1 && !collB1Overlay;
    var db1 = useB1 ? nat(b1Top) : null;
    var frameNatural =
      isRpDirect &&
      b1Bottom &&
      b1Bottom.style.display !== 'none' &&
      b1Bottom.getAttribute('src')
        ? nat(b1Bottom)
        : null;
    var scaleW = frameNatural && frameNatural.w > 1 ? frameNatural.w : wb;
    var scaleH = frameNatural && frameNatural.h > 1 ? frameNatural.h : hb;
    var centerX = W / 2;
    var centerY = H / 2;
    var maxDeviceH = isCollCard ? H * 0.48 : H * 0.52;
    var padW = isCollCard ? W * 0.84 : W * 0.93;
    var isWatchwareComposition = !!layersMeta.watchwareComposition;

    /* One global responsive scale. Direct Apple Watch already used the correct canonical
       scale because it is based on the Apple device family, not on the selected center
       image. WatchWare mode must use the same canonical scale, otherwise the exact same
       BandWare PNG becomes smaller whenever the WatchWare center image is larger. */
    var s = Math.min(1, maxDeviceH / scaleH, padW / scaleW);
    var sLayout = s;
    if (isAppleDirectFixedBand || isWatchwareComposition) {
      sLayout = getAppleDirectFixedLayoutScale(W, H, wb, hb, {
        maxDeviceHFrac: isCollCard ? 0.48 : 0.52,
        padWFrac: isCollCard ? 0.84 : 0.93,
      });
    }

    var dWf = wb * sLayout;
    var dHf = hb * sLayout;
    var tWf = wt * sLayout;
    var tHf = ht * sLayout;
    var cWf = wc * sLayout;
    var cHf = hc * sLayout;

    var isWatchwareTab = !!(this.root && this.root.classList.contains('is-watchware-tab'));
    var usePortraitStrapClamp =
      isCollCard ||
      !!(
        this.root &&
        isProductPreviewRoot(this.root) &&
        isWatchwareTab
      );
    var tWfBeforeClamp = tWf;
    var bandClamp = 1;
    var clampExecuted = false;

    /* Collection cards + BandWare PDP WatchWare — cap portrait strap (not Apple Direct fixed scale). */
    if (usePortraitStrapClamp && !isAppleDirectFixedBand && tHf > 0 && dHf > 0) {
      var maxBandH = dHf * 2.05;
      if (tHf > maxBandH) {
        bandClamp = maxBandH / tHf;
        tHf = maxBandH;
        tWf = tWf * bandClamp;
        clampExecuted = true;
        if (hc) {
          cHf = cHf * bandClamp;
          cWf = cWf * bandClamp;
        }
      }
    }

    /* Geometry V1: Royal direct BandWare assets are pre-scaled before upload.
       Do not force strap width/height to the Royal Pop device or frame. */

    var deviceTopF = centerY - dHf / 2;
    var deviceLeftF = centerX - dWf / 2;
    var deviceCenterX = deviceLeftF + dWf / 2;

    var appleDeviceOffsetXPct = parseFloat(layersMeta.appleDeviceOffsetXPct);
    if (!isFinite(appleDeviceOffsetXPct)) appleDeviceOffsetXPct = 0;
    if (isAppleDirectFixedBand && !isRpDirect && appleDeviceOffsetXPct) {
      /* Apple Watch device axis correction. Value is a percent of rendered device width,
         so it scales with the composed preview. B¹ Link/BandWare stay on the interface axis. */
      deviceLeftF += dWf * (appleDeviceOffsetXPct / 100);
    }
    var watchwareCenterOffsetXPct = parseFloat(layersMeta.watchwareCenterOffsetXPct);
    if (!isFinite(watchwareCenterOffsetXPct)) watchwareCenterOffsetXPct = 0;
    if (isWatchwareComposition && watchwareCenterOffsetXPct) {
      /* WatchWare center axis correction. Value is stored on WatchWare Line as Studio X Offset
         and applied as a percentage of the rendered WatchWare center width. BandWare stays on
         the shared interface axis. */
      deviceLeftF += dWf * (watchwareCenterOffsetXPct / 100);
    }

    var collDeviceRenderScale = 1;
    var dWfRender = dWf;
    var dHfRender = dHf;
    var deviceLeftRender = deviceLeftF;
    var deviceTopRender = deviceTopF;
    if (isRoyalCollCard && !isRpFrameBack) {
      collDeviceRenderScale = getRoyalCollDeviceRenderScale(wb, hb, W, H);
      if (collDeviceRenderScale > 1.001) {
        dWfRender = dWf * collDeviceRenderScale;
        dHfRender = dHf * collDeviceRenderScale;
        deviceLeftRender = centerX - dWfRender / 2;
        deviceTopRender = centerY - dHfRender / 2;
      }
      tWf = dWfRender * ROYAL_COLL_STRAP_TO_DEVICE_RATIO;
      if (hc) {
        cWf = tWf;
        cHf = ht > 0 ? tHf * (hc / ht) : tHf;
      }
    }
    var royalOffsetX = parseFloat(layersMeta.royalOffsetX || 0);
    var royalOffsetY = parseFloat(layersMeta.royalOffsetY || 0);
    var royalOffsetXRatio = parseFloat(layersMeta.royalOffsetXRatio);
    var royalOffsetYRatio = parseFloat(layersMeta.royalOffsetYRatio);
    var royalCrownOffsetXRatio = parseFloat(layersMeta.royalCrownOffsetXRatio);
    var royalCrownOffsetYRatio = parseFloat(layersMeta.royalCrownOffsetYRatio);
    if (!isFinite(royalOffsetX)) royalOffsetX = 0;
    if (!isFinite(royalOffsetY)) royalOffsetY = 0;
    if (!isFinite(royalOffsetXRatio)) royalOffsetXRatio = 0;
    if (!isFinite(royalCrownOffsetXRatio)) royalCrownOffsetXRatio = 0;
    if (!isFinite(royalCrownOffsetYRatio)) royalCrownOffsetYRatio = 0;
    /* Responsive default: validated manual correction was about -13px on a 255.673px rendered Royal Pop layer.
       Store/override as a ratio so it scales with the composed preview, not the monitor. */
    if (!isFinite(royalOffsetYRatio)) royalOffsetYRatio = (isRpDirect && frameNatural) ? -0.05085 : 0;
    var frameWf = frameNatural && frameNatural.w > 1 ? frameNatural.w * sLayout : dWf;
    var frameHf = frameNatural && frameNatural.h > 1 ? frameNatural.h * sLayout : dHf;
    var frameLeftF = centerX - frameWf / 2;
    var frameTopF = centerY - frameHf / 2;
    if (isRpDirect && frameNatural) {
      var royalOffsetPxX = royalOffsetX * sLayout + royalOffsetXRatio * dWf;
      var royalOffsetPxY = royalOffsetY * sLayout + royalOffsetYRatio * dHf;
      var royalBaseOffsetPxX = royalOffsetPxX + royalCrownOffsetXRatio * dWf;
      var royalBaseOffsetPxY = royalOffsetPxY + royalCrownOffsetYRatio * dHf;

      /*
        Keep the shared interface axis on the B¹ Frame/BandWare center.
        The crown-position correction is only a base-image correction, so it must
        not change deviceCenterX, topLeftF, botLeftF, or any band placement.
      */
      deviceLeftF = centerX - dWf / 2 + royalBaseOffsetPxX;
      deviceTopF = centerY - dHf / 2 + royalBaseOffsetPxY;
      deviceCenterX = centerX + royalOffsetPxX;
      if (isRoyalCollCard) {
        deviceLeftRender = centerX - dWfRender / 2 + royalBaseOffsetPxX;
        deviceTopRender = centerY - dHfRender / 2 + royalBaseOffsetPxY;
      }
    }

    /* Strap join edges — collection uses same full device box as Apple */
    var strapTopEdge = isRpDirect && frameNatural ? frameTopF : deviceTopF;
    var strapBottomEdge = isRpDirect && frameNatural ? frameTopF + frameHf : deviceTopF + dHf;
    var frameTopEdge = strapTopEdge;
    var frameBottomEdge = strapBottomEdge;
    var rpTopF = NaN;
    var rpBotF = NaN;
    /* Lug attach edges — B¹ Studio Royal only (collection uses Apple full-device stack). */
    if (isRpDirect && !isCollCard && !frameNatural) {
      rpTopF = parseFloat((base.getAttribute('data-studio-top-attach') || base.getAttribute('data-b1-top-attach')));
      rpBotF = parseFloat((base.getAttribute('data-studio-bot-attach') || base.getAttribute('data-b1-bot-attach')));
      if (isFinite(rpTopF) && isFinite(rpBotF) && rpTopF < rpBotF) {
        frameTopEdge = deviceTopF + dHf * rpTopF;
        frameBottomEdge = deviceTopF + dHf * rpBotF;
        deviceTopF = centerY - dHf * ((rpTopF + rpBotF) / 2);
        strapTopEdge = frameTopEdge;
        strapBottomEdge = frameBottomEdge;
      }
    }

    var touch = Math.max(WW_TOUCH_PX, dHf * 0.006);
    var topLeftF = deviceCenterX - tWf / 2;
    var botLeftF = deviceCenterX - cWf / 2;
    var strapOverlap = isRpDirect && !isCollCard ? dHf * 0.006 : 0;
    var topTopF = strapTopEdge - tHf + strapOverlap;
    var strapJoinTopF = strapBottomEdge - strapOverlap;
    var botTopF = strapJoinTopF;

    var b1RenderWf = 0;
    var b1RenderHf = 0;
    var b1TopLeftF = deviceCenterX;
    var b1TopTopF = strapTopEdge;
    var b1BottomLeftF = deviceCenterX;
    var b1BottomTopF = strapBottomEdge;
    var b1BottomRenderHf = 0;
    if (useB1) {
      if (isAppleDirectFixedBand && db1) {
        var db1Bot = nat(b1Bottom);
        var b1Nw = db1.w;
        var b1Nh = db1.h;
        var b1BotNh = db1Bot && db1Bot.h > 0 ? db1Bot.h : b1Nh;
        if (db1Bot && db1Bot.w > 0) b1Nw = db1Bot.w;
        b1RenderWf = b1Nw * sLayout;
        b1RenderHf = b1Nh * sLayout;
        b1BottomRenderHf = b1BotNh * sLayout;
      } else {
        var connectorWidthRatio = 0.94;
        b1RenderWf = dWf * connectorWidthRatio;
        b1RenderHf = dHf * 0.082 * 1.1;
        b1BottomRenderHf = dHf * 0.082 * 1.22;
      }
      b1TopLeftF = deviceCenterX - b1RenderWf / 2;
      b1BottomLeftF = b1TopLeftF;
      b1TopTopF = strapTopEdge - b1RenderHf * 0.42;
      b1BottomTopF = strapBottomEdge - b1BottomRenderHf * 0.58;
      if (isAppleDirectFixedBand && !isRpDirect) {
        /* Direct Apple Watch edge contract:
           top B¹ Link top edge = Apple Watch device top edge;
           top BandWare bottom edge = Apple Watch device top edge;
           bottom B¹ Link bottom edge = Apple Watch device bottom edge;
           bottom BandWare top edge = Apple Watch device bottom edge. */
        b1TopTopF = strapTopEdge;
        b1BottomTopF = strapBottomEdge - b1BottomRenderHf;
      }
      if (useB1StrapLayout) {
        if (isAppleDirectFixedBand && !isRpDirect) {
          topTopF = strapTopEdge - tHf;
          strapJoinTopF = strapBottomEdge;
        } else {
          topTopF = b1TopTopF - tHf + touch;
          strapJoinTopF = b1BottomTopF + b1BottomRenderHf - touch;
        }
        botTopF = strapJoinTopF;
      }
    }

    function placeWrap(wrap, left, top, width, height, zIndex, wrapTransform) {
      if (!wrap) return;
      wrap.style.display = 'block';
      wrap.style.position = 'absolute';
      wrap.style.left = left.toFixed(3) + 'px';
      wrap.style.top = top.toFixed(3) + 'px';
      wrap.style.width = width.toFixed(3) + 'px';
      wrap.style.height = height.toFixed(3) + 'px';
      wrap.style.zIndex = zIndex != null ? String(zIndex) : '';
      wrap.style.transform = wrapTransform || 'none';
      if (
        isLayerWrap(wrap, 'b1-top') ||
        (isLayerWrap(wrap, 'b1-bottom') && !isRpFrameBack)
      ) {
        wrap.style.overflow = 'hidden';
      } else if (
        isRpFrameBack &&
        isLayerWrap(wrap, 'b1-bottom')
      ) {
        wrap.style.overflow = 'visible';
      }
      var im = wrap.querySelector('img');
      if (im) {
        im.style.position = 'absolute';
        im.style.left = '0';
        im.style.top = '0';
        im.style.width = '100%';
        im.style.height = '100%';
        im.style.objectFit = 'contain';
        im.style.objectPosition = 'center center';
        im.style.maxWidth = 'none';
        im.style.maxHeight = 'none';
        im.style.transform = 'none';
      }
    }

    var zTopBand = (isRpDirect || isWatchwareComposition) ? 2 : 5;
    var zBase = isRpDirect ? 5 : 4;
    /* Frame behind dial (z4), device on top (z5) — finish bezel, not a cover over the whole card */
    var zFrameBack = isRpDirect ? 4 : 1;
    var zB1Top = 3;
    var zConn = 2;
    var zB1Bottom = 1;

    if (isRpFrameBack && wrapB1Bottom) {
      var frameBox = {
        left: isRpDirect && frameNatural ? frameLeftF : deviceLeftF,
        top: isRpDirect && frameNatural ? frameTopF : deviceTopF,
        width: isRpDirect && frameNatural ? frameWf : dWf,
        height: isRpDirect && frameNatural ? frameHf : dHf,
      };
      placeWrap(wrapB, topLeftF, topTopF, tWf, tHf, zTopBand);
      placeWrap(
        wrapB1Bottom,
        frameBox.left,
        frameBox.top,
        frameBox.width,
        frameBox.height,
        zFrameBack
      );
      placeWrap(
        wrapD,
        isRoyalCollCard ? deviceLeftRender : deviceLeftF,
        isRoyalCollCard ? deviceTopRender : deviceTopF,
        isRoyalCollCard ? dWfRender : dWf,
        isRoyalCollCard ? dHfRender : dHf,
        zBase
      );
      if (useConn && wrapC && hc) {
        placeWrap(wrapC, botLeftF, botTopF, cWf, cHf, zConn);
      }
    } else if (useB1StrapLayout && wrapB1Top && wrapB1Bottom) {
      placeWrap(wrapB1Bottom, b1BottomLeftF, b1BottomTopF, b1RenderWf, b1BottomRenderHf, zB1Bottom);
      if (useConn && wrapC && hc) {
        placeWrap(wrapC, botLeftF, botTopF, cWf, cHf, zConn);
      }
      placeWrap(wrapB1Top, b1TopLeftF, b1TopTopF, b1RenderWf, b1RenderHf, zB1Top, 'rotate(180deg)');
      placeWrap(
        wrapD,
        isRoyalCollCard ? deviceLeftRender : deviceLeftF,
        isRoyalCollCard ? deviceTopRender : deviceTopF,
        isRoyalCollCard ? dWfRender : dWf,
        isRoyalCollCard ? dHfRender : dHf,
        zBase
      );
      placeWrap(wrapB, topLeftF, topTopF, tWf, tHf, zTopBand);
    } else {
      if (!useB1) {
        var b1WrapsToClear = showRoyalWatchwareModel ? [wrapB1Top] : [wrapB1Top, wrapB1Bottom];
        b1WrapsToClear.forEach(function (wrap) {
          if (!wrap) return;
          ['left', 'top', 'width', 'height', 'transform', 'zIndex', 'display', 'visibility', 'overflow'].forEach(function (p) {
            wrap.style[p] = '';
          });
        });
      }
      if (collB1Overlay && useB1 && wrapB1Top && wrapB1Bottom && b1RenderWf > 0) {
        placeWrap(wrapB1Bottom, b1BottomLeftF, b1BottomTopF, b1RenderWf, b1BottomRenderHf, zB1Bottom);
        if (useConn && wrapC && hc) {
          placeWrap(wrapC, botLeftF, botTopF, cWf, cHf, zConn);
        } else if (wrapC) {
          ['left', 'top', 'width', 'height', 'transform', 'zIndex', 'display', 'visibility', 'overflow'].forEach(function (p) {
            wrapC.style[p] = '';
          });
        }
        placeWrap(wrapB1Top, b1TopLeftF, b1TopTopF, b1RenderWf, b1RenderHf, zB1Top, 'rotate(180deg)');
        placeWrap(
          wrapD,
          isRoyalCollCard ? deviceLeftRender : deviceLeftF,
          isRoyalCollCard ? deviceTopRender : deviceTopF,
          isRoyalCollCard ? dWfRender : dWf,
          isRoyalCollCard ? dHfRender : dHf,
          zBase
        );
        placeWrap(wrapB, topLeftF, topTopF, tWf, tHf, zTopBand);
      } else {
        placeWrap(wrapB, topLeftF, topTopF, tWf, tHf, zTopBand);
        if (showRoyalWatchwareModel && wrapB1Bottom) {
  var rwmNatural = nat(b1Bottom);
  var rwmBox = {
    left: deviceLeftF,
    top: deviceTopF,
    width: dWf,
    height: dHf
  };

  if (rwmNatural && rwmNatural.w > 1 && rwmNatural.h > 1) {
    var rwmWf = rwmNatural.w * sLayout;
    var rwmHf = rwmNatural.h * sLayout;

    /*
      Royal Pop / WatchWare:
      do not force the Royal Pop model into the WatchWare head box.
      Use the model image's own natural dimensions, scaled by the same compositor scale.
      Center it on the WatchWare head.
    */
    rwmBox = {
      left: deviceLeftF + dWf / 2 - rwmWf / 2,
      top: deviceTopF + dHf / 2 - rwmHf / 2,
      width: rwmWf,
      height: rwmHf
    };
  }

  /*
    Royal Pop / WatchWare model-only offset.

    Approved inspector position:
    original top: 214.179px
    approved top: 168.179px
    lift: -46px

    Approved model height:
    329.641px

    Responsive ratio:
    -46 / 329.641 = -0.1395457

    This applies only to the Royal Pop studio_watchware model layer.
    It does not affect Royal Pop Direct, WatchWare head, BandWare, B1 Frame,
    or the shared interface axis.
  */
  rwmBox.top -= rwmBox.height * 0.1395457;

  placeWrap(wrapB1Bottom, rwmBox.left, rwmBox.top, rwmBox.width, rwmBox.height, zBase + 1);
}
        placeWrap(
          wrapD,
          isRoyalCollCard ? deviceLeftRender : deviceLeftF,
          isRoyalCollCard ? deviceTopRender : deviceTopF,
          isRoyalCollCard ? dWfRender : dWf,
          isRoyalCollCard ? dHfRender : dHf,
          zBase
        );
        if (useConn && wrapC && hc) {
          placeWrap(wrapC, botLeftF, botTopF, cWf, cHf, zConn);
        } else if (wrapC) {
          ['left', 'top', 'width', 'height', 'transform', 'zIndex', 'display', 'visibility', 'overflow'].forEach(function (p) {
            wrapC.style[p] = '';
          });
        }
      }
      /* Royal collection: B¹ frame overlay — render box matches boosted device only. */
      if (
        isRoyalCollCard &&
        wrapB1Bottom &&
        b1Bottom &&
        b1Bottom.style.display !== 'none' &&
        b1Bottom.getAttribute('src')
      ) {
        placeWrap(wrapB1Bottom, deviceLeftRender, deviceTopRender, dWfRender, dHfRender, 4);
      }
    }

    var debugStrapClamp =
      typeof window !== 'undefined' &&
      (window.B1_PREVIEW_DEBUG ||
        (window.location &&
          new URLSearchParams(window.location.search).get('b1StrapClampDebug') === '1'));
    if (
      debugStrapClamp &&
      isWatchwareTab &&
      stackEl.getAttribute('data-studio-preview') === 'active'
    ) {
      var finalWatchW = isRoyalCollCard ? dWfRender : dWf;
      var strapClampDebug = {
        isCollCard: isCollCard,
        isWatchwareTab: isWatchwareTab,
        usePortraitStrapClamp: usePortraitStrapClamp,
        clampExecuted: clampExecuted,
        bandClamp: Math.round(bandClamp * 10000) / 10000,
        tWfBeforeClamp: Math.round(tWfBeforeClamp * 1000) / 1000,
        tWfAfterClamp: Math.round(tWf * 1000) / 1000,
        finalTopBandWidth: Math.round(tWf * 1000) / 1000,
        finalWatchWidth: Math.round(finalWatchW * 1000) / 1000,
        surface: isCollCard
          ? 'collection'
          : isProductPreviewRoot(this.root)
            ? 'pdp'
            : 'other',
      };
      if (typeof window !== 'undefined') {
        window.__b1StrapClampLast = strapClampDebug;
      }
    }

  };

  PreviewEngine.prototype._scheduleWatchWareLayout = function () {
    var self = this;
    if (this._wwLayoutTimer) window.clearTimeout(this._wwLayoutTimer);
    this._wwLayoutTimer = window.setTimeout(function () {
      self._wwLayoutTimer = null;
      self._runWatchWareLayoutPass();
    }, 0);
  };

  PreviewEngine.prototype._runWatchWareLayoutPass = function () {
    var self = this;
    function pass() {
      [self.stacks.active, self.stacks.prev, self.stacks.next].forEach(function (st) {
        self._requestWatchWareStackLayout(st);
      });
    }
    pass();
    window.requestAnimationFrame(pass);
    window.setTimeout(pass, 100);
    window.setTimeout(pass, 320);
  };

  /* ---------- Cart builder ---------- */
  function parseVariantId(value) {
    var id = parseInt(value, 10);
    return id > 0 ? id : 0;
  }

  function sanitizeCartItems(rawItems) {
    var items = [];
    var seen = {};
    (rawItems || []).forEach(function (item) {
      var id = parseVariantId(item && item.id);
      if (!id || seen[id]) return;
      seen[id] = true;
      items.push({ id: id, quantity: 1 });
    });
    return items;
  }

  function getCartUiElement() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  /** Dawn product-form: Shopify errors include a JSON `status` field. */
  function isShopifyCartAddError(data) {
    return !!(data && data.status);
  }

  /** Same transport as Dawn product-form.js (FormData, not JSON items[]). */
  function postCartAddFormData(formData) {
    var addUrl =
      (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    var config =
      typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : { method: 'POST', headers: { Accept: 'application/javascript' } };
    delete config.headers['Content-Type'];
    config.body = formData;
    return fetch(addUrl, config).then(function (response) {
      return response.json().then(function (data) {
        return { response: response, data: data };
      });
    });
  }

  /**
   * BandWare product page — single /cart/add.js request with items[].
   * WatchWare: band only. Direct: band + B¹ Link or B¹ Frame when adapter resolves.
   */
  function buildBandwareProductCartPayload(mode, bandModule, bandVariantId) {
    var id = parseVariantId(bandVariantId);
    if (!id) return [];
    var items = [{ id: id, quantity: 1 }];
    if (mode === 'watchware' || !bandModule) return items;
    if (!bandModule.state.adapterEnabled) return items;
    var cv = bandModule.getConnectorVariant && bandModule.getConnectorVariant();
    if (cv && cv.id && cv.available !== false) {
      items.push({ id: parseVariantId(cv.id), quantity: 1 });
    }
    return sanitizeCartItems(items);
  }

  /* One shared in-flight guard for every Studio cart controller. */
  var activeCartSubmissions = typeof WeakSet === 'function' ? new WeakSet() : null;

  function isCartSubmissionActive(button) {
    if (!button) return false;
    if (activeCartSubmissions) return activeCartSubmissions.has(button);
    return button.getAttribute('data-studio-cart-in-flight') === 'true';
  }

  function beginCartSubmission(button) {
    if (!button) return false;
    if (isCartSubmissionActive(button)) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('aria-busy', 'true');
      button.classList.add('loading');
      return false;
    }
    if (activeCartSubmissions) activeCartSubmissions.add(button);
    button.setAttribute('data-studio-cart-in-flight', 'true');
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.setAttribute('aria-busy', 'true');
    button.classList.add('loading');
    return true;
  }

  function endCartSubmission(button) {
    if (!button) return;
    if (activeCartSubmissions) activeCartSubmissions.delete(button);
    button.removeAttribute('data-studio-cart-in-flight');
    button.removeAttribute('aria-busy');
    button.removeAttribute('aria-disabled');
    button.classList.remove('loading');
  }

  /** Single JSON POST — preferred for BandWare product multi-line add. */
  function postCartAddItemsJson(items, cart) {
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    var payload = { items: sanitizeCartItems(items) };
    if (!payload.items.length) {
      return Promise.reject({ message: 'No cart items' });
    }
    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart
        .getSectionsToRender()
        .map(function (section) {
          return section.id;
        })
        .join(',');
      payload.sections_url = window.location.pathname;
    }
    var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
    if (typeof fetchConfig === 'function') {
      var cfg = fetchConfig('javascript');
      if (cfg && cfg.headers) {
        headers['X-Requested-With'] = cfg.headers['X-Requested-With'] || 'XMLHttpRequest';
      }
    }
    return fetch(addUrl, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(payload),
    }).then(function (response) {
      return response.json().then(function (data) {
        if (isShopifyCartAddError(data)) {
          return Promise.reject({ cartError: data });
        }
        return data;
      });
    });
  }

  /** Add each variant separately; only the last request asks for cart sections. */
  function addCartItemsSequential(items, cart) {
    var index = 0;
    var lastData = null;

    function addNext() {
      if (index >= items.length) {
        return Promise.resolve(lastData);
      }
      var item = items[index];
      var isLast = index === items.length - 1;
      index += 1;

      var formData = new FormData();
      formData.append('id', String(item.id));
      formData.append('quantity', String(item.quantity || 1));

      if (cart && isLast && typeof cart.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cart
            .getSectionsToRender()
            .map(function (section) {
              return section.id;
            })
            .join(',')
        );
        formData.append('sections_url', window.location.pathname);
      }

      return postCartAddFormData(formData).then(function (result) {
        if (isShopifyCartAddError(result.data)) {
          return Promise.reject({ cartError: result.data });
        }
        lastData = result.data;
        return addNext();
      });
    }

    return addNext();
  }

  function fetchCartState() {
    var url = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
    return fetch(url).then(function (response) {
      return response.json();
    });
  }

  function cartContainsVariants(cartState, variantIds) {
    if (!cartState || !cartState.items || !variantIds.length) return false;
    return variantIds.some(function (variantId) {
      return cartState.items.some(function (line) {
        return line.variant_id === variantId;
      });
    });
  }

  /** Matches cart.js onCartUpdate — works with this theme's customized drawer markup. */
  function refreshCustomCartDrawer(cart) {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    return fetch(cartUrl + '?section_id=cart-drawer')
      .then(function (response) {
        return response.text();
      })
      .then(function (responseText) {
        var html = new DOMParser().parseFromString(responseText, 'text/html');
        ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (selector) {
          var targetElement = document.querySelector(selector);
          var sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        });
        if (cart) {
          cart.classList.remove('is-empty');
          var drawerInner = cart.querySelector('.drawer__inner');
          if (drawerInner) drawerInner.classList.remove('is-empty');
        }
        return fetch(cartUrl + '?section_id=cart-icon-bubble');
      })
      .then(function (response) {
        return response.text();
      })
      .then(function (responseText) {
        var html = new DOMParser().parseFromString(responseText, 'text/html');
        var target = document.getElementById('cart-icon-bubble');
        var source =
          html.getElementById('shopify-section-cart-icon-bubble') ||
          html.querySelector('.shopify-section');
        if (target && source) {
          target.innerHTML = source.innerHTML;
        }
      });
  }

  function handleCartAddSuccess(cart, responseData, activeElement) {
    if (cart && activeElement && cart.setActiveElement) {
      cart.setActiveElement(activeElement);
    }
    if (cart) cart.classList.remove('is-empty');

    var usedRenderContents = false;
    if (
      cart &&
      responseData &&
      responseData.sections &&
      typeof cart.renderContents === 'function'
    ) {
      try {
        cart.renderContents(responseData);
        usedRenderContents = true;
      } catch (e) {
        console.warn('Brilinton: cart.renderContents failed, using section refresh', e);
      }
    }

    function publishCartUpdate() {
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'brilinton-studio',
            cartData: responseData,
          });
        }
      } catch (e) {}
    }

    if (usedRenderContents) {
      publishCartUpdate();
      if (cart && typeof cart.open === 'function') {
        return new Promise(function (resolve) {
          window.setTimeout(function () {
            cart.open(activeElement);
            resolve();
          }, 60);
        });
      }
      return Promise.resolve();
    }

    return refreshCustomCartDrawer(cart).then(function () {
      publishCartUpdate();
      if (cart && typeof cart.open === 'function') {
        cart.open(activeElement);
      }
    });
  }

  /* ---------- Apple Watch → WatchWare (metaobject-driven) ---------- *//* ---------- Apple Watch → WatchWare (metaobject-driven) ---------- */
  function wwLineStr(e) {
    if (!e || e.line == null) return '';
    var v = e.line;
    if (typeof v === 'string') return v;
    if (typeof v === 'object') {
      if (typeof v.value === 'string') return v.value;
      if (v.name) return String(v.name);
      if (v.display_name) return String(v.display_name);
    }
    return String(v);
  }
  function cleanProductFamilyLabel(title, productType) {
    if (!title) return '';
    var out = String(title).split(' | ')[0].split(' - ')[0];
    if (productType) {
      var re = new RegExp('\\s*' + productType + '\u2122?\\s*$', 'i');
      out = out.replace(re, '');
    }
    return out.replace(/\s+/g, ' ').trim();
  }

  function cleanLineLabel(line, productType) {
    var out = line == null ? '' : String(line);
    if (productType) {
      var re = new RegExp('\\s*' + productType + '\u2122?\\s*$', 'i');
      out = out.replace(re, '');
    }
    return out.replace(/\s+/g, ' ').trim();
  }


  function watchwareLineOptionLabel(line) {
    var out = cleanLineLabel(line, 'WatchWare');
    out = String(out || '').split('|')[0].replace(/WatchWare™?/ig, '').replace(/\s+/g, ' ').trim();
    // Until Edition becomes a visible selector, remove the active edition prefix from the line button.
    out = out.replace(/^Monarch\s+/i, '').trim();
    return out || cleanLineLabel(line, 'WatchWare') || String(line || '').trim();
  }

  function joinStudioSummaryLabel(primary, secondary) {
    primary = primary ? String(primary).replace(/\s+/g, ' ').trim() : '';
    secondary = secondary ? String(secondary).replace(/\s+/g, ' ').trim() : '';
    if (primary && secondary) return primary + ' / ' + secondary;
    return primary || secondary || '';
  }

  function watchwareSummaryLabel(entry, fallbackLine, fallbackFinish) {
    var finish = (entry && (entry.finish || entry.color)) || fallbackFinish || '';
    var edition = entry && entry.edition ? String(entry.edition).replace(/\s+/g, ' ').trim() : '';
    var line = '';
    var primary = '';
    if (entry && entry.productTitle) primary = cleanProductFamilyLabel(entry.productTitle, 'WatchWare');
    if (entry && entry.line) line = cleanLineLabel(wwLineStr(entry), 'WatchWare');
    if (!line) line = cleanLineLabel(fallbackLine, 'WatchWare');
    if (!primary) primary = line;
    if (edition && line) {
      var primaryLower = primary.toLowerCase();
      var editionLower = edition.toLowerCase();
      if (primaryLower.indexOf(editionLower) !== 0) {
        primary = (edition + ' ' + line).replace(/\s+/g, ' ').trim();
      }
    }
    return joinStudioSummaryLabel(primary, finish);
  }

  function bandwareSummaryLabel(entry, fallbackMaterial, fallbackColor) {
    var color = (entry && (entry.color || entry.finish)) || fallbackColor || '';
    var primary = '';
    if (entry && entry.line) primary = cleanLineLabel(entry.line, 'BandWare');
    if (!primary && entry && entry.displayTitle) primary = String(entry.displayTitle).split(',')[0];
    if (!primary && entry && entry.productTitle) primary = cleanProductFamilyLabel(entry.productTitle, 'BandWare');
    if (!primary) primary = cleanLineLabel(fallbackMaterial, 'BandWare');
    return joinStudioSummaryLabel(primary, color);
  }

  function frameSummaryLabel(frame, fallbackFinish) {
    var primary = '';
    if (frame) {
      primary = frame.type || frame.title || frame.productTitle || '';
      primary = String(primary)
        .replace(/^B[¹1]\s*Frame\s*/i, '')
        .replace(/^Frame\s*/i, '')
        .replace(/\s*Interface\s*$/i, '')
        .replace(/\s+/g, ' ')
        .trim();
    }
    var finish = fallbackFinish || '';
    if (!isMeaningfulOptionLabel(finish)) finish = '';
    if (primary && finish && norm(primary) === norm(finish)) finish = '';
    return joinStudioSummaryLabel(primary, finish);
  }

  function normalizeBandMaterialFamily(entryOrLabel) {
    var raw = '';
    if (entryOrLabel && typeof entryOrLabel === 'object') {
      raw = [
        entryOrLabel.material,
        entryOrLabel.materialFamily,
        entryOrLabel.line,
        entryOrLabel.displayTitle,
        entryOrLabel.productTitle,
      ].filter(Boolean).join(' ');
    } else {
      raw = entryOrLabel || '';
    }
    var n = norm(raw);
    if (!n) return '';
    if (n === 'metal' || n.indexOf('316l') >= 0 || n.indexOf('steel') >= 0 || n.indexOf('monarch bracelet') >= 0 || n.indexOf('bracelet') >= 0) return 'Metal';
    if (n === 'leather' || n.indexOf('slate') >= 0 || n.indexOf('ostrich') >= 0 || n.indexOf('crocodile') >= 0 || n.indexOf('ruska') >= 0 || n.indexOf('monture') >= 0 || n.indexOf('mysora') >= 0 || n.indexOf('veloute') >= 0 || n.indexOf('velout') >= 0) return 'Leather';
    if (n === 'rubber' || n.indexOf('fkm') >= 0) return 'Rubber';
    if (n === 'textile' || n.indexOf('fabric') >= 0 || n.indexOf('woven') >= 0) return 'Textile';
    if (n === 'polymer' || n.indexOf('polycarbonate') >= 0) return 'Polymer';
    if (n === 'composite' || n.indexOf('carbon') >= 0) return 'Composite';
    return String(entryOrLabel && typeof entryOrLabel === 'object' ? (entryOrLabel.material || entryOrLabel.line || '') : entryOrLabel || '').replace(/\s+/g, ' ').trim();
  }


  function AppleWatchWareMetaModule(entries) {
    this.entries = entries || [];
    this.state = { line: null, entryIndex: 0 };
    this._initDefaults();
  }

  AppleWatchWareMetaModule.prototype._initDefaults = function () {
    var lines = this.getUniqueLines();
    if (!lines.length) return;
    this.state.line = lines[0];
    var list = this.getEntriesForLine(this.state.line);
    this.state.entryIndex = list.length ? list[0].index : 0;
  };

  AppleWatchWareMetaModule.prototype.getUniqueLines = function () {
    var seen = {};
    var out = [];
    this.entries.forEach(function (e) {
      var line = wwLineStr(e);
      if (!line || seen[norm(line)]) return;
      seen[norm(line)] = true;
      out.push(line);
    });
    return out;
  };

  AppleWatchWareMetaModule.prototype.getEntriesForLine = function (line) {
    return this.entries.filter(function (e) {
      return norm(wwLineStr(e)) === norm(line);
    });
  };

  AppleWatchWareMetaModule.prototype.getSelectedEntry = function () {
    var list = this.getEntriesForLine(this.state.line);
    for (var i = 0; i < list.length; i++) {
      if (list[i].index === this.state.entryIndex) return list[i];
    }
    return list[0] || null;
  };

  AppleWatchWareMetaModule.prototype.getFirstWatchViewInLine = function (line) {
    var list = this.getEntriesForLine(line);
    for (var i = 0; i < list.length; i++) {
      if (list[i].watchView) return list[i].watchView;
    }
    return null;
  };

  AppleWatchWareMetaModule.prototype.getWatchView = function () {
    var e = this.getSelectedEntry();
    if (e && e.watchView) return e.watchView;
    if (this.state.line) {
      var byLine = this.getFirstWatchViewInLine(this.state.line);
      if (byLine) return byLine;
    }
    for (var j = 0; j < this.entries.length; j++) {
      if (this.entries[j].watchView) return this.entries[j].watchView;
    }
    return null;
  };

  AppleWatchWareMetaModule.prototype.getStudioGeometry = function () {
    function hasGeometry(geom) {
      if (!geom) return false;
      return (
        geom.interfaceOffsetXPct != null ||
        geom.offsetX != null ||
        geom.offsetY != null ||
        geom.offsetXRatio != null ||
        geom.offsetYRatio != null
      );
    }
    function geometryFromEntry(entry) {
      if (!entry) return null;
      var labels = [
        entry.variantTitle,
        entry.variant_title,
        entry.size,
        entry.device_size,
        entry.watchSize,
        entry.selectedSize,
        entry.finish
      ].filter(Boolean);
      var candidates = [
        entry.studio_x_offset,
        entry.studioXOffset,
        entry.line_studio_x_offset,
        entry.lineStudioXOffset,
        entry.line_studio_x_offset_raw,
        entry.lineStudioXOffsetRaw,
        entry.scale_data,
        entry.scaleData,
        entry.geometry
      ];
      for (var c = 0; c < candidates.length; c++) {
        var geom = parseStudioGeometry(candidates[c], labels);
        if (hasGeometry(geom)) return geom;
      }
      return null;
    }

    var e = this.getSelectedEntry();
    var geom = geometryFromEntry(e);
    if (hasGeometry(geom)) return geom;

    /* The WatchWare offset belongs to the Line. If the selected Profile did not emit it,
       scan every emitted entry in the same Line and use the first Line geometry value.
       This keeps the offset shared at Line level instead of duplicating it on Profiles. */
    var line = this.state.line || wwLineStr(e);
    var list = line ? this.getEntriesForLine(line) : this.entries;
    for (var i = 0; i < list.length; i++) {
      geom = geometryFromEntry(list[i]);
      if (hasGeometry(geom)) return geom;
    }
    for (var j = 0; j < this.entries.length; j++) {
      geom = geometryFromEntry(this.entries[j]);
      if (hasGeometry(geom) && norm(wwLineStr(this.entries[j])) === norm(line)) return geom;
    }
    return null;
  };

  AppleWatchWareMetaModule.prototype.selectLine = function (line) {
    this.state.line = line;
    var list = this.getEntriesForLine(line);
    this.state.entryIndex = list.length ? list[0].index : 0;
  };

  AppleWatchWareMetaModule.prototype.selectEntryIndex = function (entryIndex) {
    this.state.entryIndex = entryIndex;
  };

  AppleWatchWareMetaModule.prototype.getSummaryItems = function () {
    var e = this.getSelectedEntry();
    if (!e || !e.variantId) return [];
    return [{ label: e.productTitle || 'WatchWare', price: Number(e.price) || 0 }];
  };

  function findMatchingFrameVariant(bFrame, frameOptionIdx, position, finish) {
    if (!bFrame) return null;
    return findVariantByIndices(
      bFrame,
      frameOptionIdx.position,
      position,
      frameOptionIdx.finish,
      finish
    );
  }

  function finishSlugForMatch(finish) {
    return norm(finish).replace(/\s+/g, '');
  }

  function isMeaningfulOptionLabel(label) {
    if (!label) return false;
    var n = norm(label);
    var slug = finishSlugForMatch(label);
    return !!(n && n !== 'default title' && slug !== 'defaulttitle');
  }

  function findFrameVariantByFinish(bFrame, frameOptionIdx, finish) {
    if (!bFrame || !bFrame.variants || !bFrame.variants.length) return null;
    var finishIdx = frameOptionIdx.finish;
    var target = norm(finish);
    var targetSlug = finishSlugForMatch(finish);
    for (var i = 0; i < bFrame.variants.length; i++) {
      var v = bFrame.variants[i];
      var optVal = optByIndex(v, finishIdx);
      if (norm(optVal) === target || finishSlugForMatch(optVal) === targetSlug) return v;
      if (norm(v.title) === target || finishSlugForMatch(v.title) === targetSlug) return v;
    }
    for (var k = 0; k < bFrame.variants.length; k++) {
      if (bFrame.variants[k].available) return bFrame.variants[k];
    }
    return bFrame.variants[0];
  }

  var ROYAL_FINISH_PARAM_ALIASES = {
    rosegold: 'Rose Gold',
    'rose-gold': 'Rose Gold',
  };

  function matchRoyalFinishParam(param, availableFinishes) {
    if (!param || !availableFinishes || !availableFinishes.length) return null;
    var slug = finishSlugForMatch(param);
    var alias = ROYAL_FINISH_PARAM_ALIASES[slug];
    if (alias) {
      for (var a = 0; a < availableFinishes.length; a++) {
        if (norm(availableFinishes[a]) === norm(alias)) return availableFinishes[a];
      }
    }
    for (var i = 0; i < availableFinishes.length; i++) {
      if (finishSlugForMatch(availableFinishes[i]) === slug) return availableFinishes[i];
    }
    return null;
  }

  /** Direct flow UI keys — Royal Pop defaults match Apple until customized. */
  var DIRECT_CONFIG = {
    apple_watch: {
      selectors: {
        materials: '[data-b1-bw-materials]',
        colors: '[data-b1-bw-colors]',
        finish: '[data-b1-bw-finish]',
        deviceSize: '[data-b1-device-size]',
      },
      attrs: {
        materialBtn: 'data-b1-bw-material-btn',
        colorBtn: 'data-b1-bw-color-btn',
        finishBtn: 'data-b1-bw-finish-btn',
      },
      accordion: {
        device: 'bw-size',
        bandware: 'bw-bandware',
        connector: 'bw-link',
      },
    },
    royal_pop: {
      selectors: {
        materials: '[data-b1-rp-bw-materials]',
        colors: '[data-b1-rp-bw-colors]',
        finish: '[data-b1-rp-finish]',
        deviceSize: null,
      },
      attrs: {
        materialBtn: 'data-b1-rp-bw-material-btn',
        colorBtn: 'data-b1-rp-bw-color-btn',
        finishBtn: 'data-b1-rp-finish-btn',
      },
      accordion: {
        device: 'rp-model',
        bandware: 'rp-bandware',
        connector: 'rp-frame',
      },
    },
  };

  /**
   * Shared Direct preview layer map (Apple Watch Direct + Royal Pop Direct).
   * PreviewEngine positions layers; only asset URLs differ per flow.
   */
  function buildDirectPreviewLayers(bandModule, entry) {
    var frameSrc = bandModule.getConnectorImage ? bandModule.getConnectorImage() : null;
    var b1Key = frameSrc
      ? finishSlugForUrl(bandModule.state.linkFinish) + '|' + frameSrc
      : '';
    var royalGeometry = bandModule.getRoyalGeometry ? bandModule.getRoyalGeometry() : null;
    var royalOffsetX = royalGeometry && royalGeometry.offsetX != null ? royalGeometry.offsetX : 0;
    var royalOffsetY = royalGeometry && royalGeometry.offsetY != null ? royalGeometry.offsetY : 0;
    var royalOffsetXRatio = royalGeometry && royalGeometry.offsetXRatio != null ? royalGeometry.offsetXRatio : (royalGeometry && royalGeometry.offsetXPercent != null ? royalGeometry.offsetXPercent / 100 : null);
    var royalOffsetYRatio = royalGeometry && royalGeometry.offsetYRatio != null ? royalGeometry.offsetYRatio : (royalGeometry && royalGeometry.offsetYPercent != null ? royalGeometry.offsetYPercent / 100 : null);
    var royalCrownOffsetXRatio = royalGeometry && royalGeometry.crownOffsetXRatio != null ? royalGeometry.crownOffsetXRatio : null;
    var royalCrownOffsetYRatio = royalGeometry && royalGeometry.crownOffsetYRatio != null ? royalGeometry.crownOffsetYRatio : null;
    if (bandModule.isRoyalDirect && bandModule.isCollectionPreview) {
      return {
        base: bandModule.getDeviceImage(),
        band: entry && entry.topBand ? entry.topBand : null,
        connector: entry && entry.bottomBand ? entry.bottomBand : null,
        showConnector: !!(entry && entry.bottomBand),
        b1FrameBack: frameSrc,
        showB1FrameBack: !!frameSrc,
        showB1Connectors: false,
        b1Connector: null,
        normalizeBase: true,
        royalDirectComposition: true,
        strapHeightRatio: null,
        royalOffsetX: royalOffsetX,
        royalOffsetY: royalOffsetY,
        royalOffsetXRatio: royalOffsetXRatio,
        royalOffsetYRatio: royalOffsetYRatio,
        royalCrownOffsetXRatio: royalCrownOffsetXRatio,
        royalCrownOffsetYRatio: royalCrownOffsetYRatio,
        crownPosition: bandModule.state.framePosition,
      };
    }
    if (bandModule.isRoyalDirect) {
      return {
        base: bandModule.getDeviceImage(),
        band: entry && entry.topBand ? entry.topBand : null,
        connector: entry && entry.bottomBand ? entry.bottomBand : null,
        showConnector: !!(entry && entry.bottomBand),
        b1FrameBack: frameSrc,
        showB1FrameBack: !!frameSrc,
        showB1Connectors: false,
        b1Connector: null,
        normalizeBase: true,
        royalDirectComposition: true,
        strapHeightRatio: null,
        royalOffsetX: royalOffsetX,
        royalOffsetY: royalOffsetY,
        royalOffsetXRatio: royalOffsetXRatio,
        royalOffsetYRatio: royalOffsetYRatio,
        royalCrownOffsetXRatio: royalCrownOffsetXRatio,
        royalCrownOffsetYRatio: royalCrownOffsetYRatio,
        crownPosition: bandModule.state.framePosition,
      };
    }
    var appleGeometry = bandModule.getAppleGeometry ? bandModule.getAppleGeometry() : null;
    var appleOffsetXPct = appleGeometry && appleGeometry.interfaceOffsetXPct != null ? appleGeometry.interfaceOffsetXPct : 0;
    return {
      base: bandModule.getDeviceImage(),
      band: entry && entry.topBand ? entry.topBand : null,
      connector: entry && entry.bottomBand ? entry.bottomBand : null,
      showConnector: !!(entry && entry.bottomBand),
      b1Connector: frameSrc,
      b1ConnectorKey: b1Key,
      showB1Connectors: !!frameSrc,
      normalizeBase: false,
      royalDirectComposition: false,
      strapHeightRatio: null,
      crownPosition: null,
      appleDeviceOffsetXPct: appleOffsetXPct,
      appleDirectFixedScale: true,
    };
  }



  /* ---------- BandWare module (Direct — Apple Watch + Royal Pop) ---------- */
  function BandWareModule(data, root, bandCells, options) {
    options = options || {};
    this.directKey = options.directKey || 'apple_watch';
    this.directCfg = DIRECT_CONFIG[this.directKey] || DIRECT_CONFIG.apple_watch;
    this.isRoyalDirect = this.directKey === 'royal_pop';
    this.isCollectionPreview = !!options.collectionPreview;
    this.bLink = data.bLink;
    this.bFrame = data.bFrame;
    this.interfaceFrames = data.interfaceFrames || [];
    this.frameOptionIdx = data.frameOptionIdx || { position: 0, finish: 1 };
    this.royalModels = data.royalModels || [];
    this.appleSizes = data.appleSizes || [];
    this.linkOptionIdx = data.linkOptionIdx || { size: 0, finish: 1 };
    this.entries =
      this.isRoyalDirect
        ? data.royalPopBandWareEntries || data.appleBandWareEntries || []
        : data.appleBandWareEntries || [];
    this.state = {
      bandIndex: 0,
      material: null,
      deviceSize: null,
      linkFinish: null,
      frameIndex: 0,
      adapterEnabled: true,
      modelIndex: 0,
      framePosition: null,
      strapHeightRatio: null,
    };
    this.royalWatchModule = null;
    this._strapRatioKey = '';
    this._initDefaults();
  }

  BandWareModule.prototype.computeRoyalStrapRatioForEntry = function (entry, watchViewOverride) {
    if (!this.isRoyalDirect || !entry || !entry.topBand) return Promise.resolve(null);
    var watchView =
      watchViewOverride ||
      (this.getDeviceImage && this.getDeviceImage()) ||
      null;
    var topBand = entry.topBand;
    if (!watchView || !topBand) return Promise.resolve(null);
    return Promise.all([loadImageNaturalSize(watchView), loadImageNaturalSize(topBand)]).then(
      function (sizes) {
        var watchSize = sizes[0];
        var bandSize = sizes[1];
        if (!watchSize || !bandSize || watchSize.h < 2 || bandSize.h < 2) return null;
        return bandSize.h / watchSize.h;
      }
    );
  };

  BandWareModule.prototype.syncRoyalStrapHeightRatio = function (watchModule) {
    if (!this.isRoyalDirect) return Promise.resolve(false);
    var watchView =
      watchModule && watchModule.getWatchView ? watchModule.getWatchView() : null;
    if (!watchView) watchView = this.getDeviceImage();
    var entry = this.getSelectedEntry();
    var topBand = entry && entry.topBand;
    if (!watchView || !topBand) return Promise.resolve(false);
    var key = watchView + '|' + topBand;
    if (this._strapRatioKey === key && this.state.strapHeightRatio > 0) {
      return Promise.resolve(false);
    }
    var self = this;
    return Promise.all([loadImageNaturalSize(watchView), loadImageNaturalSize(topBand)]).then(
      function (sizes) {
        var watchSize = sizes[0];
        var bandSize = sizes[1];
        if (!watchSize || !bandSize || watchSize.h < 2 || bandSize.h < 2) {
          return false;
        }
        var ratio = bandSize.h / watchSize.h;
        var changed = self.state.strapHeightRatio !== ratio;
        self.state.strapHeightRatio = ratio;
        self._strapRatioKey = key;
        return changed;
      }
    );
  };

  BandWareModule.prototype._initDefaults = function () {
    if (this.isCollectionPreview) {
      if (this.isRoyalDirect && this.royalModels.length) {
        this.selectRoyalModel(0);
      }
      this.state.deviceSize = null;
      this.state.linkFinish = null;
      var collMaterials = this.getUniqueMaterials();
      if (collMaterials.length) this.state.material = collMaterials[0];
      return;
    }
    if (this.isRoyalDirect) {
      if (this.royalModels.length) this.selectRoyalModel(0);
    } else if (this.appleSizes.length) {
      this.state.deviceSize = this.appleSizes[0].device_size;
    }
    var finishes = this.getAvailableFinishes();
    this.state.linkFinish = this.isRoyalDirect ? (finishes[0] || null) : (finishes[0] || 'Gold');
    var materials = this.getUniqueMaterials();
    if (materials.length) this.state.material = materials[0];
  };

  BandWareModule.prototype.getFrameEntries = function () {
    return this.interfaceFrames && this.interfaceFrames.length ? this.interfaceFrames : [];
  };

  BandWareModule.prototype.getSelectedFrame = function () {
    var frames = this.getFrameEntries();
    if (!frames.length) return null;
    var idx = Math.max(0, Math.min(this.state.frameIndex || 0, frames.length - 1));
    return frames[idx] || frames[0] || null;
  };

  BandWareModule.prototype.selectFrameIndex = function (index) {
    var frames = this.getFrameEntries();
    if (!frames.length) {
      this.state.frameIndex = 0;
      return;
    }
    this.state.frameIndex = Math.max(0, Math.min(Number(index) || 0, frames.length - 1));
    var finishes = this.getAvailableFinishes();
    if (finishes.length) {
      var ok = finishes.some(function (f) { return norm(f) === norm(this.state.linkFinish); }, this);
      if (!ok) this.state.linkFinish = finishes[0];
    } else {
      this.state.linkFinish = null;
    }
  };

  BandWareModule.prototype._getFrameProduct = function () {
    return this.getSelectedFrame() || this.bFrame || null;
  };

  BandWareModule.prototype._getFrameOptionIdx = function () {
    var frame = this.getSelectedFrame();
    if (frame && frame.finishOptionIdx != null) {
      return { position: 0, finish: Number(frame.finishOptionIdx) || 0 };
    }
    return this.frameOptionIdx || { position: 0, finish: 1 };
  };

  BandWareModule.prototype.getRoyalModel = function () {
    return this.royalModels[this.state.modelIndex] || this.royalModels[0] || null;
  };

  BandWareModule.prototype.getRoyalGeometry = function () {
    var m = this.getRoyalModel ? this.getRoyalModel() : null;
    if (!m) return null;
    var geom = parseStudioGeometry(m.scale_data || m.scaleData || m.geometry || null);
    return applyRoyalCrownPositionGeometry(geom, m.crown_position || m.crownPosition || null);
  };

  BandWareModule.prototype.getAppleGeometry = function () {
    if (this.isRoyalDirect || !this.getSizeEntry) return null;
    var entry = this.getSizeEntry();
    if (!entry) return null;
    return parseStudioGeometry(entry.studio_x_offset || entry.studioXOffset || entry.scale_data || entry.scaleData || entry.geometry || null);
  };

  BandWareModule.prototype.selectRoyalModel = function (index) {
    this.state.modelIndex = index;
    var m = this.getRoyalModel();
    if (!m) return;
    this.state.framePosition = m.crown_position || null;
    var finishes = this.getAvailableFinishes();
    if (m.recommended_finish && finishes.some(function (f) { return norm(f) === norm(m.recommended_finish); })) {
      this.state.linkFinish = m.recommended_finish;
    } else if (!this.state.linkFinish || !finishes.some(function (f) { return norm(f) === norm(this.state.linkFinish); }, this)) {
      this.state.linkFinish = finishes[0] || null;
    }
  };

  BandWareModule.prototype.getUniqueMaterials = function () {
    var seen = {};
    var out = [];
    this.entries.forEach(function (e) {
      var m = normalizeBandMaterialFamily(e);
      if (!m || seen[norm(m)]) return;
      seen[norm(m)] = true;
      out.push(m);
    });
    return out;
  };

  BandWareModule.prototype.getFilteredEntries = function () {
    var mat = this.state.material;
    if (!mat) return this.entries.slice();
    return this.entries.filter(function (e) {
      return norm(normalizeBandMaterialFamily(e)) === norm(mat);
    });
  };

  BandWareModule.prototype.selectMaterial = function (material) {
    this.state.material = material != null ? String(material) : '';
    this.state.bandIndex = 0;
  };

  BandWareModule.prototype.getSizeEntry = function () {
    var ds = this.state.deviceSize;
    for (var i = 0; i < this.appleSizes.length; i++) {
      if (norm(this.appleSizes[i].device_size) === norm(ds)) return this.appleSizes[i];
    }
    return null;
  };

  BandWareModule.prototype.getLinkSizeLabel = function () {
    var e = this.getSizeEntry();
    return e ? e.b1_link_size : null;
  };

  BandWareModule.prototype.getDeviceImage = function () {
    if (this.isRoyalDirect) {
      var m = this.getRoyalModel();
      if (!m) return null;
      // Same layout anchor as Apple Direct (device_image), not card thumbnail (image).
      return m.device_image || m.preview_image || m.image || null;
    }
    var e = this.getSizeEntry();
    if (e && e.device_image) return e.device_image;
    for (var i = 0; i < this.appleSizes.length; i++) {
      if (this.appleSizes[i].device_image) return this.appleSizes[i].device_image;
    }
    return null;
  };

  BandWareModule.prototype.getAvailableFinishes = function () {
    if (this.isRoyalDirect) {
      var frameProduct = this._getFrameProduct();
      if (!frameProduct || !frameProduct.variants || !frameProduct.variants.length) return [];
      var idx = this._getFrameOptionIdx().finish;
      var vals = uniqueVals(frameProduct.variants, idx).filter(function (v) {
        return isMeaningfulOptionLabel(v);
      });
      return vals;
    }
    var linkSize = this.getLinkSizeLabel();
    if (!linkSize || !this.bLink) return [];
    var li = this.linkOptionIdx;
    return uniqueVals(
      this.bLink.variants.filter(function (v) {
        return norm(optByIndex(v, li.size)) === norm(linkSize);
      }),
      li.finish
    );
  };

  BandWareModule.prototype.getConnectorVariant = function () {
    if (this.isRoyalDirect) {
      return findFrameVariantByFinish(this._getFrameProduct(), this._getFrameOptionIdx(), this.state.linkFinish);
    }
    if (!this.bLink) return null;
    var li = this.linkOptionIdx;
    return findVariantByIndices(
      this.bLink,
      li.size,
      this.getLinkSizeLabel(),
      li.finish,
      this.state.linkFinish,
      { exactOnly: this.isCollectionPreview }
    );
  };

  /** B¹ interface preview image. Frame keeps its existing source; Link uses only Interface Profile assets. */
  BandWareModule.prototype.getConnectorImage = function () {
    if (!this.state.adapterEnabled) return null;
    if (this.isRoyalDirect) {
      var cv = this.getConnectorVariant();
      if (cv && cv.featured_image) return cv.featured_image;
      var frame = this.getSelectedFrame();
      if (frame && frame.studioImage) return frame.studioImage;
      return null;
    }
    return resolveB1LinkStudioImage(this.bLink, this.state.linkFinish, this.getLinkSizeLabel());
  };

  BandWareModule.prototype.getLinkVariant = function () {
    return this.getConnectorVariant();
  };

  BandWareModule.prototype.getEntriesList = function () {
    return this.getFilteredEntries();
  };

  BandWareModule.prototype.getSelectedEntry = function () {
    var list = this.getFilteredEntries();
    var i = Math.max(0, Math.min(this.state.bandIndex, list.length - 1));
    return list[i] || null;
  };

  BandWareModule.prototype.selectBandIndex = function (index) {
    var len = this.getFilteredEntries().length;
    if (!len) {
      this.state.bandIndex = 0;
      return;
    }
    this.state.bandIndex = Math.max(0, Math.min(index, len - 1));
  };

  BandWareModule.prototype.wrapIndex = function (i) {
    var len = this.getFilteredEntries().length;
    if (!len) return 0;
    return ((i % len) + len) % len;
  };

  BandWareModule.prototype.getCarouselIndices = function () {
    var len = this.getFilteredEntries().length;
    var cur = len ? Math.max(0, Math.min(this.state.bandIndex, len - 1)) : 0;
    if (len <= 1) return { current: cur, prev: cur, next: cur, single: true };
    return {
      current: cur,
      prev: (cur - 1 + len) % len,
      next: (cur + 1) % len,
      single: false,
    };
  };

  BandWareModule.prototype.goCarousel = function (direction) {
    var c = this.getCarouselIndices();
    this.selectBandIndex(direction === 'next' ? c.next : c.prev);
  };

  BandWareModule.prototype.buildPreviewForEntry = function (entry) {
    return buildDirectPreviewLayers(this, entry);
  };

  BandWareModule.prototype.getPreviewView = function () {
    var list = this.getFilteredEntries();
    var len = list.length;
    var cur = len ? Math.max(0, Math.min(this.state.bandIndex, len - 1)) : 0;
    var curE = list[cur];
    var prevE = list[this.wrapIndex(cur - 1)];
    var nextE = list[this.wrapIndex(cur + 1)];
    var title = curE ? curE.productTitle || '' : '';
    if (curE && curE.color) title += (title ? ' · ' : '') + curE.color;
    return {
      active: this.buildPreviewForEntry(curE),
      prev: this.buildPreviewForEntry(prevE),
      next: this.buildPreviewForEntry(nextE),
      title: title,
      single: len <= 1,
    };
  };

  BandWareModule.prototype.getSummaryItems = function () {
    var items = [];
    var entry = this.getSelectedEntry();
    if (entry) {
      items.push({
        label: entry.productTitle || 'BandWare',
        price: Number(entry.price) || 0,
      });
    }
    if (this.state.adapterEnabled) {
      var cv = this.getConnectorVariant();
      if (cv) {
        items.push({
          label: (this.isRoyalDirect ? ((this.getSelectedFrame() && this.getSelectedFrame().title) || (this.bFrame && this.bFrame.title) || 'B¹ Frame') : this.bLink.title) + (cv && cv.title && isMeaningfulOptionLabel(cv.title) ? ' — ' + cv.title : ''),
          price: cv.price,
        });
      }
    }
    return items;
  };

  /** Collapsible sections — UI only; does not change panel hide/show. */
  function buildWatchWarePreviewLayers(watchModule, bandEntry) {
    var watchView = watchModule && watchModule.getWatchView ? watchModule.getWatchView() : null;
    var watchGeometry = watchModule && watchModule.getStudioGeometry ? watchModule.getStudioGeometry() : null;
    var watchOffsetXPct = watchGeometry && watchGeometry.interfaceOffsetXPct != null ? watchGeometry.interfaceOffsetXPct : 0;
    return {
      base: watchView || null,
      band: bandEntry && bandEntry.topBand ? bandEntry.topBand : null,
      connector: bandEntry && bandEntry.bottomBand ? bandEntry.bottomBand : null,
      showConnector: !!(bandEntry && bandEntry.bottomBand),
      watchwareComposition: true,
      watchwareCenterOffsetXPct: watchOffsetXPct,
    };
  }

  var B1_CONFIG_URL = {
    DEVICE: 'device',
    MODE: 'mode',
    SIZE: 'size',
    LINK: 'link',
    MODEL: 'model',
    FRAME: 'frame',
    FRAME_TYPE: 'frame_type',
    FRAME_FINISH: 'frame_finish',
    WATCHWARE: 'watchware',
    LINE: 'line',
    FINISH: 'finish',
    BAND: 'band',
    BAND_COLOR: 'band_color',
    BAND_MATERIAL: 'band_material',
    ADAPTER: 'adapter',
  };

  function hasB1ConfigParams(params) {
    if (!params) return false;
    var P = B1_CONFIG_URL;
    return (
      params.has(P.DEVICE) ||
      params.has(P.MODE) ||
      params.has(P.SIZE) ||
      params.has(P.LINK) ||
      params.has(P.MODEL) ||
      params.has(P.FRAME) ||
      params.has(P.FRAME_TYPE) ||
      params.has(P.FRAME_FINISH) ||
      params.has(P.WATCHWARE) ||
      params.has(P.LINE) ||
      params.has(P.FINISH) ||
      params.has(P.BAND) ||
      params.has(P.BAND_COLOR) ||
      params.has(P.BAND_MATERIAL) ||
      params.has(P.ADAPTER)
    );
  }

  function parseAdapterFromParams(params) {
    if (!params) return true;
    var raw = params.get(B1_CONFIG_URL.ADAPTER);
    if (raw == null || raw === '') return true;
    return raw !== '0' && raw !== 'false' && raw !== 'off';
  }

  function watchwareParamsFromEntry(entry) {
    if (!entry) return { line: null, finish: null };
    return {
      line: wwLineStr(entry),
      finish: entry.finish || null,
    };
  }

  function finishSlugForUrl(finish) {
    if (!finish) return '';
    return String(finish)
      .toLowerCase()
      .replace(/\u2019/g, "'")
      .replace(/[\s_]+/g, '')
      .trim();
  }

  var LINK_FINISH_PARAM_ALIASES = {
    rosegold: 'Rose Gold',
  };

  function matchFinishFromParam(param, available, normFn) {
    if (!param || !available || !available.length) return null;
    var alias = LINK_FINISH_PARAM_ALIASES[finishSlugForUrl(param)];
    var target = finishSlugForUrl(alias || param);
    for (var i = 0; i < available.length; i++) {
      if (finishSlugForUrl(available[i]) === target) return available[i];
      if (normFn(available[i]) === normFn(alias || param)) return available[i];
    }
    return null;
  }

  function matchSizeFromParam(param, sizes, normFn) {
    if (!param) return null;
    var p = normFn(param);
    for (var i = 0; i < sizes.length; i++) {
      if (normFn(sizes[i].device_size) === p) return sizes[i].device_size;
    }
    return null;
  }

  function modelSlugForUrl(name) {
    return String(name || '')
      .toLowerCase()
      .replace(/\u2019/g, "'")
      .replace(/[\s_]+/g, '-')
      .replace(/[^a-z0-9-]/g, '')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function matchModelIndexFromParam(param, models, normFn) {
    if (param == null || param === '' || !models || !models.length) return null;
    var idx = parseInt(param, 10);
    if (!isNaN(idx) && idx >= 0 && idx < models.length) return idx;
    var target = modelSlugForUrl(param);
    for (var i = 0; i < models.length; i++) {
      if (modelSlugForUrl(models[i].name) === target) return i;
      if (normFn(models[i].name) === normFn(param)) return i;
    }
    return null;
  }

  function deviceSlugFromPlatform(platform) {
    if (platform === 'royal') return 'royal-pop';
    return 'apple-watch';
  }

  function parseDeviceParam(param) {
    if (!param) return null;
    var p = String(param)
      .toLowerCase()
      .replace(/[\s_]+/g, '-')
      .trim();
    if (p === 'apple-watch' || p === 'apple') return 'apple';
    if (p === 'royal-pop' || p === 'royal') return 'royal';
    return null;
  }

  function resolveModeFromParams(params, opts) {
    opts = opts || {};
    var modeParam = params.get(B1_CONFIG_URL.MODE);
    if (modeParam === 'watchware' && opts.hasWatchWare) return 'watchware';
    if (modeParam === 'direct') return 'direct';
    if (
      params.get(B1_CONFIG_URL.LINE) &&
      params.get(B1_CONFIG_URL.FINISH) &&
      opts.hasWatchWare
    ) {
      return 'watchware';
    }
    if (params.get(B1_CONFIG_URL.WATCHWARE) && opts.hasWatchWare) return 'watchware';
    if (opts.isRoyal && (params.get(B1_CONFIG_URL.MODEL) || params.get(B1_CONFIG_URL.FRAME) || params.get(B1_CONFIG_URL.FRAME_TYPE) || params.get(B1_CONFIG_URL.FRAME_FINISH))) {
      return 'direct';
    }
    if (params.get(B1_CONFIG_URL.SIZE) || params.get(B1_CONFIG_URL.LINK)) return 'direct';
    return null;
  }

  function buildConfigUrl(pathname, config, preserveSearch) {
    var url = preserveSearch
      ? new URL(window.location.href)
      : new URL(pathname, window.location.origin);
    if (!preserveSearch) {
      url.pathname = pathname;
      url.search = '';
    }
    url.searchParams.delete(B1_CONFIG_URL.DEVICE);
    url.searchParams.delete(B1_CONFIG_URL.MODE);
    url.searchParams.delete(B1_CONFIG_URL.SIZE);
    url.searchParams.delete(B1_CONFIG_URL.LINK);
    url.searchParams.delete(B1_CONFIG_URL.MODEL);
    url.searchParams.delete(B1_CONFIG_URL.FRAME);
    url.searchParams.delete(B1_CONFIG_URL.FRAME_TYPE);
    url.searchParams.delete(B1_CONFIG_URL.FRAME_FINISH);
    url.searchParams.delete(B1_CONFIG_URL.WATCHWARE);
    url.searchParams.delete(B1_CONFIG_URL.LINE);
    url.searchParams.delete(B1_CONFIG_URL.FINISH);
    url.searchParams.delete(B1_CONFIG_URL.BAND);
    url.searchParams.delete(B1_CONFIG_URL.BAND_COLOR);
    url.searchParams.delete(B1_CONFIG_URL.BAND_MATERIAL);
    url.searchParams.delete(B1_CONFIG_URL.ADAPTER);

    if (!config) return url.pathname + url.search + url.hash;

    var deviceSlug = config.device || deviceSlugFromPlatform(config.platform);
    if (deviceSlug) url.searchParams.set(B1_CONFIG_URL.DEVICE, deviceSlug);

    if (!config.mode) return url.pathname + url.search + url.hash;

    var isRoyal = config.platform === 'royal' || deviceSlug === 'royal-pop';

    if (config.mode === 'watchware' && (config.line || config.finish)) {
      url.searchParams.set(B1_CONFIG_URL.MODE, 'watchware');
      if (config.line) {
        url.searchParams.set(B1_CONFIG_URL.LINE, watchwareSlugPart(config.line));
      }
      if (config.finish) {
        url.searchParams.set(B1_CONFIG_URL.FINISH, watchwareSlugPart(config.finish));
      }
      if (isRoyal && config.model != null && config.model !== '') {
        url.searchParams.set(B1_CONFIG_URL.MODEL, String(config.model));
      }
    } else if (config.mode === 'direct') {
      url.searchParams.set(B1_CONFIG_URL.MODE, 'direct');
      if (isRoyal) {
        if (config.model != null && config.model !== '') {
          url.searchParams.set(B1_CONFIG_URL.MODEL, String(config.model));
        }
        if (config.frameType) url.searchParams.set(B1_CONFIG_URL.FRAME_TYPE, watchwareSlugPart(config.frameType));
        if (config.frameFinish) url.searchParams.set(B1_CONFIG_URL.FRAME_FINISH, finishSlugForUrl(config.frameFinish));
        if (!config.frameType && config.frame) url.searchParams.set(B1_CONFIG_URL.FRAME, finishSlugForUrl(config.frame));
      } else {
        if (config.size) url.searchParams.set(B1_CONFIG_URL.SIZE, config.size);
        if (config.link) url.searchParams.set(B1_CONFIG_URL.LINK, finishSlugForUrl(config.link));
      }
      if (config.adapter === false) {
        url.searchParams.set(B1_CONFIG_URL.ADAPTER, '0');
      }
    } else if (isRoyal) {
      if (config.model != null && config.model !== '') {
        url.searchParams.set(B1_CONFIG_URL.MODEL, String(config.model));
      }
      if (config.frameType) url.searchParams.set(B1_CONFIG_URL.FRAME_TYPE, watchwareSlugPart(config.frameType));
      if (config.frameFinish) url.searchParams.set(B1_CONFIG_URL.FRAME_FINISH, finishSlugForUrl(config.frameFinish));
      if (!config.frameType && config.frame) url.searchParams.set(B1_CONFIG_URL.FRAME, finishSlugForUrl(config.frame));
    } else if (config.size || config.link) {
      if (config.size) url.searchParams.set(B1_CONFIG_URL.SIZE, config.size);
      if (config.link) url.searchParams.set(B1_CONFIG_URL.LINK, finishSlugForUrl(config.link));
    }

    if (config.band) {
      url.searchParams.set(B1_CONFIG_URL.BAND, watchwareSlugPart(config.band));
    }
    if (config.bandColor) {
      url.searchParams.set(B1_CONFIG_URL.BAND_COLOR, watchwareSlugPart(config.bandColor));
    }
    if (config.bandMaterial) {
      url.searchParams.set(B1_CONFIG_URL.BAND_MATERIAL, watchwareSlugPart(config.bandMaterial));
    }

    return url.pathname + url.search + url.hash;
  }

  function watchwareSlugPart(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/\u2019/g, "'")
      .replace(/[\s_]+/g, '-')
      .replace(/[^a-z0-9-]/g, '')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function watchwareSlugFromEntry(entry) {
    if (!entry) return '';
    return watchwareSlugPart(wwLineStr(entry)) + '-' + watchwareSlugPart(entry.finish);
  }

  /** Collection grid cards — wait for layout after images (+ Royal Pop model crop). */
  function renderCollectionCardPreview(engine, view, forceRefresh, extraRelayoutPasses) {
    return new Promise(function (resolve) {
      if (!engine || !view || !engine.isValidView(view)) {
        resolve();
        return;
      }
      engine.render(view, !!forceRefresh);
      if (!engine.root.classList.contains('is-ww-js-layout')) {
        resolve();
        return;
      }
      function relayout() {
        engine._runWatchWareLayoutPass();
      }
      var delays = extraRelayoutPasses
        ? [40, 120, 260, 420, 640, 920, 1200]
        : [40, 200, 420];
      delays.forEach(function (ms, idx) {
        window.setTimeout(function () {
          relayout();
          if (idx === delays.length - 1) resolve();
        }, ms);
      });
    });
  }

  function renderRoyalCollectionCardPreview(engine, bandModule, entry, forceRefresh) {
    if (!bandModule || !entry) return Promise.resolve();
    return bandModule.computeRoyalStrapRatioForEntry(entry).then(function (ratio) {
      var layers = buildDirectPreviewLayers(bandModule, entry);
      if (ratio != null && isFinite(ratio) && ratio > 0) {
        layers.strapHeightRatio = ratio;
      }
      return renderCollectionCardPreview(
        engine,
        { active: layers, single: true },
        !!forceRefresh,
        true
      );
    });
  }

  function matchWatchwareFromParam(param, entries) {
    if (!param || !entries || !entries.length) return null;
    var target = watchwareSlugPart(param);
    for (var i = 0; i < entries.length; i++) {
      if (watchwareSlugFromEntry(entries[i]) === target) return entries[i];
    }
    var parts = String(param).split('-');
    if (parts.length >= 2) {
      var finishGuess = parts[parts.length - 1];
      var lineGuess = parts.slice(0, -1).join('-');
      for (var j = 0; j < entries.length; j++) {
        if (
          watchwareSlugPart(wwLineStr(entries[j])) === lineGuess &&
          watchwareSlugPart(entries[j].finish) === finishGuess
        ) {
          return entries[j];
        }
      }
    }
    return null;
  }

  /**
   * Canonical WatchWare URL hydration — line+finish first, legacy watchware slug fallback.
   */
  function resolveWatchwareFromParams(params, entries) {
    var empty = { entry: null, line: null, finish: null, source: null };
    if (!params || !entries || !entries.length) return empty;

    var lineParam = params.get(B1_CONFIG_URL.LINE);
    var finishParam = params.get(B1_CONFIG_URL.FINISH);
    if (lineParam && finishParam) {
      var lineTarget = watchwareSlugPart(lineParam);
      var finishTarget = watchwareSlugPart(finishParam);
      for (var i = 0; i < entries.length; i++) {
        if (
          watchwareSlugPart(wwLineStr(entries[i])) === lineTarget &&
          watchwareSlugPart(entries[i].finish) === finishTarget
        ) {
          return {
            entry: entries[i],
            line: wwLineStr(entries[i]),
            finish: entries[i].finish,
            source: 'line-finish',
          };
        }
      }
    }

    var wwParam = params.get(B1_CONFIG_URL.WATCHWARE);
    if (wwParam) {
      var slugEntry = matchWatchwareFromParam(wwParam, entries);
      if (slugEntry) {
        return {
          entry: slugEntry,
          line: wwLineStr(slugEntry),
          finish: slugEntry.finish,
          source: 'watchware-slug',
        };
      }
    }

    return empty;
  }


  function matchBandEntryFromParams(params, entries) {
    if (!params || !entries || !entries.length) return null;
    var bandParam = params.get(B1_CONFIG_URL.BAND);
    var colorParam = params.get(B1_CONFIG_URL.BAND_COLOR);
    if (!bandParam && !colorParam) return null;
    var bandTarget = watchwareSlugPart(bandParam || '');
    var colorTarget = watchwareSlugPart(colorParam || '');

    function entryLineMatches(entry) {
      if (!bandTarget) return true;
      var candidates = [
        entry && entry.productHandle,
        entry && entry.line,
        entry && entry.lineName,
        entry && entry.displayTitle,
        entry && entry.productTitle,
        entry && entry.title,
      ];
      for (var i = 0; i < candidates.length; i++) {
        var candidate = watchwareSlugPart(candidates[i]);
        if (candidate === bandTarget || candidate.indexOf(bandTarget) >= 0 || bandTarget.indexOf(candidate) >= 0) return true;
      }
      return false;
    }

    for (var i = 0; i < entries.length; i++) {
      var entry = entries[i] || {};
      var color = watchwareSlugPart(entry.color || entry.finish || entry.bandFinish || '');
      if (entryLineMatches(entry) && (!colorTarget || color === colorTarget)) return entry;
    }
    if (colorTarget) {
      for (var j = 0; j < entries.length; j++) {
        var fallback = entries[j] || {};
        if (watchwareSlugPart(fallback.color || fallback.finish || fallback.bandFinish || '') === colorTarget) return fallback;
      }
    }
    return null;
  }

  function matchFrameIndexFromParam(param, frames) {
    if (!param || !frames || !frames.length) return null;
    var target = watchwareSlugPart(param);
    for (var i = 0; i < frames.length; i++) {
      var frame = frames[i] || {};
      var candidates = [frame.type, frame.title, frame.productTitle, frame.productHandle];
      for (var j = 0; j < candidates.length; j++) {
        if (watchwareSlugPart(candidates[j]) === target) return i;
      }
    }
    return null;
  }

  /** Shared by collection BandWare configurator (apple-watch-bands). */
  window.B1PreviewKit = {
    norm: norm,
    q: q,
    qa: qa,
    PreviewEngine: PreviewEngine,
    BandWareModule: BandWareModule,
    AppleWatchWareMetaModule: AppleWatchWareMetaModule,
    wwLineStr: wwLineStr,
    normalizeBandMaterialFamily: normalizeBandMaterialFamily,
    watchwareLineOptionLabel: watchwareLineOptionLabel,
    frameSummaryLabel: frameSummaryLabel,
    buildDirectPreviewLayers: buildDirectPreviewLayers,
    buildWatchWarePreviewLayers: buildWatchWarePreviewLayers,
    computeRoyalStrapRatioForEntry: function (bandModule, entry, watchViewOverride) {
      if (!bandModule || !bandModule.computeRoyalStrapRatioForEntry) return Promise.resolve(null);
      return bandModule.computeRoyalStrapRatioForEntry(entry, watchViewOverride);
    },
    renderCollectionCardPreview: renderCollectionCardPreview,
    renderRoyalCollectionCardPreview: renderRoyalCollectionCardPreview,
    parseStudioGeometry: parseStudioGeometry,
    applyRoyalCrownPositionGeometry: applyRoyalCrownPositionGeometry,
    initCollAppleReferenceProbe: initCollAppleReferenceProbe,
    initCollAppleMaxDeviceProbe: initCollAppleMaxDeviceProbe,
    getAppleDirectFixedLayoutScale: getAppleDirectFixedLayoutScale,
    getAppleCollDirectLayoutScale: getAppleCollDirectLayoutScale,
    loadImageNaturalSize: loadImageNaturalSize,
    watchwareSlugFromEntry: watchwareSlugFromEntry,
    watchwareParamsFromEntry: watchwareParamsFromEntry,
    matchWatchwareFromParam: matchWatchwareFromParam,
    resolveWatchwareFromParams: resolveWatchwareFromParams,
    hasB1ConfigParams: hasB1ConfigParams,
    parseAdapterFromParams: parseAdapterFromParams,
    findVariantByIndices: findVariantByIndices,
    uniqueVals: uniqueVals,
    optByIndex: optByIndex,
    b1LinkStudioKey: b1LinkStudioKey,
    resolveB1LinkStudioImage: resolveB1LinkStudioImage,
    B1_CONFIG_URL: B1_CONFIG_URL,
    buildConfigUrl: buildConfigUrl,
    deviceSlugFromPlatform: deviceSlugFromPlatform,
    parseDeviceParam: parseDeviceParam,
    resolveModeFromParams: resolveModeFromParams,
    matchFinishFromParam: matchFinishFromParam,
    matchSizeFromParam: matchSizeFromParam,
    matchModelIndexFromParam: matchModelIndexFromParam,
    matchRoyalFinishParam: matchRoyalFinishParam,
    matchBandEntryFromParams: matchBandEntryFromParams,
    matchFrameIndexFromParam: matchFrameIndexFromParam,
    sanitizeCartItems: sanitizeCartItems,
    getCartUiElement: getCartUiElement,
    isShopifyCartAddError: isShopifyCartAddError,
    beginCartSubmission: beginCartSubmission,
    endCartSubmission: endCartSubmission,
    isCartSubmissionActive: isCartSubmissionActive,
    handleCartAddSuccess: handleCartAddSuccess,
    buildBandwareProductCartPayload: buildBandwareProductCartPayload,
    postCartAddItemsJson: postCartAddItemsJson,
  };
})();
